{
  "translation": {
    "ai_templates": {
      "menu_title_pet": "Retratos de mascotas",
      "menu_title_family": "Retratos familiares",
      "menu_title_kids": "Arte infantil de pared",
      "menu_title_places": "Arte de Lugares",
      "menu_title_travel_posters": "Pósters de viaje",
      "menu_title_vintage_posters": "Pósters vintage",
      "menu_title_home_hobbies": "Hogar y aficiones",
      "menu_title_kitchen_art": "Arte de cocina",
      "menu_title_food_drink_art": "Comida y bebida",
      "menu_title_food_recipe_art": "Comida y recetas",
      "menu_title_travel": "Viajes",
      "kids_wall": {
        "child_name": "Nombre del niño/a",
        "interests_label": "Nombra 2-3 cosas que le encantan",
        "interests_placeholder": "ej., dinosaurios, fútbol, unicornios",
        "interests_hint": "Evita personajes registrados"
      },
      "upload_menu": {
        "text_input_title": "Nombre de la mascota (opcional)",
        "create": "Crear",
        "processing": "Procesando...",
        "upload_photo": "Subir Foto",
        "cta": {
          "upload_pet_photo": "Subir Foto de Mascota",
          "upload_couple_photo": "Subir Foto de Pareja",
          "upload_old_photo": "Subir Foto Antigua",
          "upload_photo_with_faces": "Subir Foto con Rostros",
          "upload_scenic_photo": "Subir Foto de Paisaje",
          "upload_family_photo": "Subir Foto Familiar"
        }
      },
      "faces_selection": {
        "generate_button": "Generar Fotos ({{count}} {{label}})",
        "no_faces_detected": "No se detectaron rostros",
        "people": "Personas",
        "pet": "Mascota",
        "pets": "Mascotas",
        "portraits": "Retratos",
        "person": "Persona",
        "subtitle": "Asegúrate de que los rostros sean claros y muestren los ojos y el cabello",
        "title": "Seleccionar Rostros"
      },
      "multi_upload": {
        "cta": "Subir 1-9 Fotos",
        "title": "Para los mejores resultados"
      },
      "results": {
        "add_tile": "Añadir Tile",
        "next": "Siguiente"
      },
      "loading": {
        "creating_photos": "Creando Fotos..."
      },
      "variations": {
        "generation_failed": "No pudimos crear tu nuevo estilo. Inténtalo de nuevo.",
        "create_button_one": "Crear {{count}} retrato",
        "create_button_other": "Crear {{count}} retratos",
        "add_portraits_line_1": "Añade retratos",
        "add_portraits_line_2": "para",
        "add_portraits_for_pet": "Añade retratos para tu mascota",
        "change_pet_photo": "Cambiar foto de mascota",
        "back_to_add_options": "Volver a las opciones",
        "load_failed": "No pudimos cargar los estilos. Inténtalo de nuevo.",
        "no_more_templates": "No hay más plantillas para tu mascota",
        "generating_snackbar": "Creando"
      },
      "errors": {
        "unexpected_error": "Error en la generación de imagen",
        "safety_reject": "Imagen rechazada por razones de seguridad",
        "service_unavailable": "Error: Servicio no disponible",
        "image_too_large": "Error: Imagen demasiado grande",
        "image_processing_failed": "Error: No se pudo procesar la imagen",
        "rate_limit": "Has alcanzado el límite de solicitudes de hoy. Inténtalo de nuevo mañana."
      },
      "variants": {
        "boy": "Niño",
        "girl": "Niña"
      }
    },
    "art": {
      "collection": {
        "categories": {
          "Abstract": "Abstracto",
          "Animals": "Animales",
          "Beach": "Playa",
          "Best Sellers": "Más Vendidos",
          "Botanical": "Botánico",
          "Classic Art": "Arte Clásico",
          "Destinations": "Destinos",
          "Faith": "Fe",
          "Famous Artists": "Artistas famosos",
          "Flowers": "Flores",
          "Geometric": "Geométrico",
          "Kids": "Niños",
          "Kitchen": "Cocina",
          "Lines": "Líneas",
          "Mountains": "Montañas",
          "Nature": "Naturaleza",
          "Plants": "Plantas",
          "Sayings": "Frases",
          "Travel": "Viajes",
          "Urban": "Urbano",
          "Dogs & Cats": "Perros y Gatos"
        }
      },
      "home": {
        "cta_browse": "Explorar Arte",
        "subtitle": "Encuentra, enmarca y cuelga fácilmente el arte que amas",
        "title": "Decora Tus Paredes en Minutos",
        "title_with_category": "La Colección {{v1}}"
      },
      "select_art": "Seleccionar Arte"
    },
    "business": {
      "add_emails": "Agregar correos",
      "company_name": "Nombre de la empresa",
      "contact_form_title": "Completa este formulario y uno de nuestros expertos se pondrá en contacto pronto.",
      "csv": "Subir archivo CSV",
      "desired_amount_of_tiles": "Cantidad de cuadros deseada",
      "employees_gift_cards": "Tarjetas de regalo para empleados",
      "employees_to_be_gifted": "Empleados a ser beneficiados",
      "gift_card_for_title": "Tarjetas de regalo digitales, descuento por cantidad.",
      "submit": {
        "subtitle": "Uno de nuestros expertos se contactará pronto.",
        "title": "¡Gracias! Tu solicitud ha sido recibida."
      },
      "subtitle": "Experimenta la facilidad y belleza de los cuadros fotográficos personalizados. Nuestros paquetes especiales B2B ofrecen descuentos especiales y soporte de expertos.",
      "title": "No son los típicos obsequios corporativos.",
      "your_name": "Tu nombre"
    },
    "centerpiece": {
      "add_wall_sign": "Agregar Letrero de Pared",
      "bottom_text": "TEXTO INFERIOR",
      "customize": "Personalizar",
      "top_text": "TEXTO SUPERIOR"
    },
    "download_app": {
      "card": {
        "title": "Tu Galería de Pared Ya Está Lista",
        "subtitle": "Nuestra app crea galerías de pared espectaculares con tus mejores fotos"
      },
      "hero": {
        "title": "Tus Álbumes de Fotos Ya Están Listos",
        "subtitle": "Nuestra app crea álbumes de fotos espectaculares con tus mejores fotos"
      },
      "cta": "Descarga la App"
    },
    "collage": {
      "add_more": "Agregar más fotos para crear un collage",
      "collage": "Collage",
      "edit_collage": "Editar Collage",
      "exceeding_photos": {
        "choose_photos_plural": "Elige {{v1}} fotos para este diseño",
        "choose_photos_singular": "Elige una foto para este diseño",
        "select_more_photos_plural": "Selecciona {{v1}} Fotos Más",
        "select_more_photos_singular": "Selecciona 1 Foto Más"
      },
      "layout_rearrange_notice": "Esto reorganizará el diseño",
      "text_limit_reached": "Has alcanzado el límite de texto",
      "text_unsupported_size": "Cambia el tamaño para añadir texto"
    },
    "designer": {
      "add_tile_or_collage_to_enable_bulk_editing": "Agrega un Cuadro o Collage para Habilitar la Edición Múltiple",
      "add_tile_to_enable_bulk_editing": "Agrega cuadros para habilitar la edición múltiple",
      "adjust_crop_description": "Pellizca para acercar o mueve con tu dedo",
      "adjust_crop_description_desktop": "Desplaza para acercar, arrastra para mover",
      "adjust_crop_hint": "Pellizca o arrastra para ajustar",
      "adjust_crop_hint_desktop": "Arrastra para ajustar",
      "bold": "Negrita",
      "border": "Borde",
      "bulk_override_warning": {
        "apply_filter": "Aplicar Filtro",
        "apply_frame_color": "Aplicar Marco",
        "apply_mat": "Aplicar Borde",
        "apply_material": "Aplicar material",
        "apply_size": "Aplicar Tamaño",
        "apply_to_all": "Aplicar a todo",
        "title": "¿Aplicar este cambio a todos los cuadros?"
      },
      "change_mat": "Prueba un borde diferente para ver colores.",
      "change_mat_notifications": {
        "disabled": "Disponible en otros tipos de marco",
        "partial_apply": {
          "generic_material_subtitle": "Algunos cuadros no admiten bordes",
          "single_material_subtitle": "{{v1}} no admite bordes",
          "title": "Bordes aplicados parcialmente"
        }
      },
      "choose_swap": "Elige una foto para intercambiar",
      "classic": "Clásico",
      "color": "Color",
      "crop": "Ajuste",
      "delete": "Borrar",
      "duplicate": "Duplicar",
      "drop_files": "Suelta las fotos para subir",
      "effect": "Efecto",
      "excellent_quality": {
        "cta": "Entendido",
        "subtitle": "Te notificaremos si hay algún problema.",
        "title": "¡Excelente calidad de foto!"
      },
      "frameless_8x8_caption": "Solo {{v1}}",
      "filter": "Filtro",
      "frame": "Marco",
      "handwriting": "Caligrafía",
      "layout": "Diseño",
      "mat": "Borde",
      "material": "Material",
      "mixed_sizes": "Tamaños Mixtos",
      "out_of_stock_warning": {
        "approve": "Cambiar a {{size}}",
        "cancel": "Quedarse con {{material}}",
        "title": "Los cuadros de {{size}} {{material}} están agotados",
        "out_of_stock": "Agotado",
        "product_approve": "Cambiar a {{product}}",
        "product_cancel": "Quedarme con {{product}}",
        "product_title": "{{product}} están agotados"
      },
      "photos": "Fotos",
      "progress_bar": {
        "adding_photos": "Agregando fotos…",
        "framing_your_photos": "Enmarcando tus fotos..."
      },
      "select_border": "Seleccionar Borde",
      "select_effect": "Seleccionar Efecto",
      "select_filter": "Seleccionar Filtro",
      "select_frame": "Seleccionar Marco",
      "select_frame_color": "Selecciona el color del marco",
      "select_layout": "Seleccionar Diseño",
      "select_mat": "Seleccionar Efecto del Borde",
      "select_material": "Seleccionar Material",
      "select_matting": "Seleccionar Borde",
      "select_size": "Seleccionar Tamaño",
      "select_style": "Seleccionar Estilo",
      "select_text_style": "Elige el estilo del texto",
      "size": "Tamaño",
      "swap_positions": "Intercambiar Posiciones",
      "tile_deleted": "Cuadro eliminado",
      "wide": "Ancho",
      "bad_crop": {
        "approve_btn": "Aprobar y Hacer Pedido",
        "back_btn": "Atrás",
        "desktop_subtitle": "Desplaza para acercar, arrastra para mover",
        "edit": "Editar Pedido Completo",
        "mobile_subtitle": "Pellizca para acercar, arrastra para mover",
        "next_btn": "Siguiente",
        "review_btn": "Revisar Fotos",
        "title": "¡Asegurémonos de que tus fotos estén recortadas a tu gusto!"
      },
      "matting": "paspartú",
      "recommended_size": "Recomendado {{v1}} o más pequeño",
      "select_color": "Seleccionar Color",
      "text": "texto"
    },
    "general": {
      "address_form": {
        "add_title": "Añadir dirección",
        "change_save": "Actualizar",
        "change_title": "Cambiar Dirección",
        "form_fields": {
          "address": "Dirección",
          "address_2": "Dirección 2",
          "city": "Ciudad",
          "country": "País",
          "full_name": "Nombre y Apellidos",
          "full_name_kana": "Nombre en Katakana",
          "full_name_kana_placeholder": "Ingresa la lectura en katakana del nombre",
          "phone": "Número de Teléfono",
          "postal": "Código Postal",
          "province": "Provincia",
          "state": "Estado",
          "state_or_province": "Estado / Provincia",
          "state_or_territory": "Estado/Territorio",
          "zip": "Código Postal"
        },
        "phone_number_info": "El número de teléfono solo se usará en caso de que necesitemos contactarte para la entrega",
        "suggest_offers": "Recibir ofertas exclusivas por SMS y aplicaciones de mensajería.",
        "suggest_offers_email": "Suscríbeme para recibir actualizaciones por email sobre ofertas exclusivas",
        "re_enter_address": "Reingresar Dirección",
        "use_this_address_anyway": "Usar esta dirección igualmente",
        "validation_errors": {
          "address": {
            "invalid": "Ciudad/Provincia/CódigoPostal Incorrecto",
            "not_found": "Dirección Incorrecta",
            "not_supported": "Lo sentimos, los pedidos de {{product}} no están disponibles en tu país"
          },
          "city_state": {
            "invalid": "Ciudad o Provincia Incorrecta"
          },
          "country": {
            "unsupported": "¡Lo siento! No enviamos a tu país todavía"
          },
          "email": {
            "invalid": "Por favor ingresa un email válido"
          },
          "full_name": {
            "invalid": "Porfa, introduce tu nombre completo (nombre y apellido)"
          },
          "full_name_kana": {
            "missing": "Porfa, introduce la lectura en kana de tu nombre",
            "invalid": "La lectura debe ser solo hiragana o katakana"
          },
          "non_latin_characters": "Por favor, utiliza solo caracteres latinos",
          "house_number": {
            "invalid": "Número de la Calle Incorrecto",
            "missing": "Falta el Número de la Calle"
          },
          "missing_fields": {
            "general": "Por favor completa todos los campos requeridos para continuar",
            "specific": "Completa tu {{v1}} para continuar"
          },
          "name": {
            "invalid": "Por favor ingresa tu nombre",
            "too_long": "El nombre no puede exceder {{v1}} caracteres"
          },
          "phone": {
            "invalid": "Por favor ingresa un número de teléfono válido"
          },
          "secondary_information": {
            "invalid": "Número de Piso Incorrecto",
            "missing": "Falta el número de piso"
          },
          "state": {
            "invalid": "Provincia Incorrecta"
          },
          "street": {
            "invalid": "Nombre de la Calle Incorrecto",
            "missing": "Falta el Nombre de la Calle",
            "po_box": "No podemos enviar a apartados de correos"
          },
          "mind_another_look": "¿Te importaría revisarla?",
          "zip": {
            "invalid": "Código Postal Incorrecto",
            "not_found": "Código Postal Incorrecto",
            "state_mismatch": "El código postal y el estado no coinciden",
            "unsupported_territory": "No enviamos a esta región"
          }
        }
      },
      "applied": "aplicado",
      "auto_save_message": "Mixtiles guarda automáticamente tu trabajo",
      "best_seller": "Más vendido",
      "add": "Añadir",
      "cancel": "Cancelar",
      "credits": {
        "balance": "Tienes {{v1}} en créditos"
      },
      "discard_changes": "Descartar cambios",
      "done": "Listo",
      "each": "cada uno",
      "errors": {
        "dark_mode_subTitle": "Cambia al modo claro en la configuración del sistema para ver el color real.",
        "dark_mode_title": "El modo oscuro muestra los colores del marco incorrectamente.",
        "general_description": "¡Uy, lo siento! Porfa, prueba de nuevo y si sigue igual, avísanos. ",
        "general_description_short": "Por favor, inténtalo de nuevo",
        "general_title": "¡Ups! Algo ha salido mal...",
        "general_title_short": "Algo salió mal",
        "order_cancelled_title": "Pedido Cancelado",
        "order_cancelled_refund_subtitle": "El reembolso está siendo procesado",
        "webgl_not_supported_subtitle": "Abre esta página en Safari o Chrome para ver esta vista previa.",
        "webgl_not_supported_title": "Esta vista previa no se puede mostrar en este navegador"
      },
      "from_price": "Desde {{v1}}",
      "gdpr_dialog": {
        "privacy_policy": "Política de Privacidad",
        "terms_of_use": "Condiciones de uso"
      },
      "got_it": "Entendido",
      "languages": {
        "change_language": "Cambiar Idioma",
        "de": "Deutsch",
        "en": "English",
        "es": "Español",
        "fr": "Français",
        "ja": "日本語",
        "language": "Idioma"
      },
      "menu": {
        "accessibility_button": "Accesibilidad",
        "add_promo_code": {
          "modal": {
            "form_title": "Tu código",
            "placeholder": "Introdúcelo Aquí",
            "title": "Promociones",
            "title_with_gift_card": "Añade código de promoción o tarjeta de regalo"
          },
          "success": {
            "code_applied": "{{v1}} Aplicado"
          }
        },
        "art_collection": "Colección de arte",
        "buy_gift_card": "Comprar tarjeta de regalo",
        "chat_with_us": "Habla con Nosotros",
        "cookie_policy": "Política de Cookies",
        "faq": "Preguntas Frecuentes",
        "for_business": "Regalo corporativo",
        "frame_your_photos": "Enmarca Tus Fotos",
        "gift_card": "Comprar Tarjeta Regalo",
        "gift_card_v2": "Tarjeta Regalo",
        "help_center": "Centro de ayuda",
        "my_orders": "Mis Pedidos",
        "privacy_policy": "Política de Privacidad",
        "promo_code_manager": {
          "promo_codes": "Códigos de Descuento"
        },
        "use_code_to_save": "Código '{{v1}}' aplicado, ahorra hasta un {{v2}}%. El descuento varía según el tamaño y el material."
      },
      "new": "Nuevo",
      "ok": "OK",
      "optional": "Opcional",
      "payment_form": {
        "header": "Dirección de Facturación",
        "same_shipping_address": "Las direcciones de facturación y envío son las mismas",
        "validation_errors": {
          "address": {
            "missing": "Completa los detalles de la dirección para continuar"
          },
          "missing_fields": {
            "general": "Completa los detalles de pago para continuar"
          }
        }
      },
      "promo_code_selector": {
        "default": "predeterminado",
        "disclaimer": "El descuento varía según el tamaño y el material.",
        "free_tile_description": "{{v1}} cuadros de {{v2}} gratis",
        "free_book_description": "{{v1}} libros de fotos de {{v2}} gratis",
        "free_tiles": "Cuadros Gratis",
        "free_books": "Libros de Fotos Gratis",
        "promo_not_applied_to_product": "Esta promoción no se aplica a {{v1}}",
        "select_volume_discount": "Seleccionar Descuento por Cantidad",
        "volume_discount_applied": "Descuento por Cantidades Aplicado",
        "gift_card_description": "{{v1}} de crédito ({{v2}} disponible)"
      },
      "promo_code_success_dialog": {
        "call_to_action": "Comprar ahora",
        "save_message_on_product": "Ahorra {{v1}} en {{v2}}",
        "save_up_to_message_shortened": "Ahorra hasta {{v1}}%",
        "size_and_material_disclaimer": "Ahorra hasta un {{v1}}%. El descuento varía según el tamaño y el material.",
        "subtitle": {
          "gift_card": "Has añadido {{v1}} con éxito",
          "gift_card_tiles_many": "{{v1}} cuadros gratis",
          "gift_card_tiles_one": "un cuadro gratis",
          "gift_card_books_many": "{{v1}} libros de fotos gratis",
          "gift_card_books_one": "un libro de fotos gratis"
        },
        "title": {
          "bundle": "{{v1}}{{size_constraint}} Cuadros por {{v2}}",
          "free_tiles_many": "¡Tienes {{v1}} cuadros gratis{{size_constraint}}!",
          "gift_card": "¡Tarjeta Regalo Aplicada!"
        }
      },
      "refresh": "Actualizar",
      "skip": "Saltar",
      "start_creating": "Comenzar a crear",
      "continue_design": "Continuar diseño",
      "talk_to_us": "Escríbenos",
      "try_again": "Reintentar",
      "learn_more": "Más Información"
    },
    "google_photos": {
      "authorize_title": "Conectar con Google Fotos",
      "authorize": "Entrar",
      "select_title": "Abrir Google Fotos en una nueva pestaña para seleccionar fotos",
      "select_photos": "Abrir pestaña",
      "error_title": "Error",
      "error_message": "Algo salió mal. Inténtalo de nuevo.",
      "try_again": "Reintentar",
      "fetching_title": "Cargando fotos",
      "step_1": "Paso 1",
      "step_2": "Paso 2",
      "adding_photos": "Añadiendo…",
      "google_photos_requires_safari": "Google Fotos requiere abrirse en Safari",
      "open_safari": "Abrir en Safari",
      "stay_here": "Quedarse aquí",
      "disconnect": "Desconectar de Google Fotos"
    },
    "get_started": {
      "form_fields": {
        "email": "Email"
      },
      "title": "Conozcámonos"
    },
    "gift_card": {
      "books": "Libros",
      "buy_now": "Comprar ahora",
      "delivered_by_email_with_expiry": "Entregado por correo electrónico, esta tarjeta de regalo nunca expira",
      "form": {
        "add_email_address": "Añade correo electrónico",
        "card_value_label": "Elige el valor de la tarjeta",
        "choose_book_size": "Elige el tamaño del libro",
        "custom_placeholder": "Personaliza",
        "design_label": "Elige un diseño",
        "gift_message_label": "Mensaje de regalo (opcional)",
        "gift_message_placeholder": "Añade una nota personal",
        "gift_scheduler_label": "¿Cuándo deberíamos enviar la tarjeta de regalo?",
        "now": "Ahora",
        "recipient_email_placeholder": "Correo del beneficiario",
        "recipient_label": "¿Quién es el afortunado beneficiario?",
        "sender_label": "¿De quién es?",
        "sender_name_placeholder": "Nombre del remitente",
        "today": "Hoy"
      },
      "number_of_books": "{{v1}} libros, {{v2}}",
      "number_of_tiles": "{{v1}} Cuadros",
      "prepay_save_up_to": "Prepaga y ahorra hasta {{v1}}%",
      "prepay_save_exact": "Prepaga y ahorra {{v1}}%",
      "sizes_note_2": "Solo disponible para cuadros de {{v1}} con marcos o sin marcos.",
      "switch_gift_card_type_cta": "Cambiar",
      "switch_to_tile_based_description": "a nuestra otra tarjeta de regalo - elige por la cantidad de cuadros o libros que quieres dar",
      "switch_to_value_based_description": "para nuestras tarjetas de regalo regulares, donde tú compras basado en la cantidad de dinero que quieres dar. Aplica para todos los tamaños y materiales.",
      "tiles": "Cuadros",
      "title_digital": "Tarjeta de regalo digital",
      "your_email": "Tu Email"
    },
    "holidays": {
      "arrives_before_christmas": "Llega antes de Navidad",
      "arrives_before_fathers_day": "Llega antes del Día del Padre",
      "arrives_before_mothers_day": "Llega antes del Día de las Madres",
      "arrives_before_valentines_day": "Llega antes de San Valentín",
      "arrives_before_veterans_day": "Llega antes del Día de los Veteranos",
      "get_it_by_christmas": "Recíbelo para Navidad",
      "get_it_by_fathers_day": "Recíbelo para el Día del Padre",
      "get_it_by_mothers_day": "Recíbelo para el Día de las Madres",
      "get_it_by_valentines_day": "Recíbelo para San Valentín",
      "get_it_by_veterans_day": "Recíbelo para el Día de los Veteranos"
    },
    "homepage": {
      "photo_books_banner": {
        "subtitle": "Visto en TV,\nPide ahora",
        "cta": "Pruébalo ahora"
      },
      "beauty": {
        "subtitle": "Cada álbum viene con una cubierta dura mate y está impreso en páginas premium con un acabado sedoso.",
        "title": "Belleza en cada página",
        "design_subtitle": "Una tapa dura diseñada para cada viaje, con impresión premium y páginas satinadas para una colección atemporal",
        "design_title": "Diseñados para Coleccionar",
        "life_events_subtitle": "Una tapa dura bellamente elaborada, con impresión premium y páginas satinadas para una colección que atesorarás por siempre",
        "life_events_title": "Diseñados para Coleccionar"
      },
      "chat": {
        "content": "Habla con nuestro equipo de soporte real, todos los días de 7 a. m. a medianoche (hora del Este de EE. UU.)",
        "cta": "Habla Con Nosotros",
        "title": "¿Necesitas Ayuda?"
      },
      "community": {
        "subtitle_black_frames": "Marcos {{v1}} Negros",
        "subtitle_white_frames": "Marcos {{v1}} blancos",
        "subtitle_wood_frames": "Marcos {{v1}} de madera",
        "subtitle_wood_mixed_frames": "Marcos de madera de tamaños mixtos",
        "title": "Desde Nuestra Comunidad"
      },
      "cookies_choices": "Tus opciones de privacidad",
      "covered": {
        "rated_subtitle": "{{v1}}+ calificaciones en la App Store",
        "reviews": "reseñas",
        "shipping": "Envío Rápido y Gratuito",
        "shipping_free_subtitle": "No hay mínimo requerido",
        "shipping_subtitle": "*Envío gratis a partir de {{v1}}",
        "support": "Atención Al Cliente Personalizada",
        "support_short": "Soporte Dedicado",
        "support_subtitle": "Personas reales listas para ayudar",
        "title": "Te Cubrimos la Espalda",
        "trustpilot": "Calificado como Excelente en Trustpilot",
        "rated": "Valorado {{v1}}"
      },
      "faq": {
        "frames": {
          "content": "Los tamaños varían de {{v1}} a {{v2}}, además de una opción única de {{v3}}. Disponible en varios materiales y colores de marco, incluidas opciones sin marco y con lienzo.",
          "title": "¿Cuánto miden los cuadros?"
        },
        "frames-art": {
          "content": "Los tamaños varían de {{v1}} a {{v2}}. Disponible en varios materiales y colores de marco, incluidas opciones sin marco y con lienzo.",
          "title": "¿Cuánto miden los cuadros?"
        },
        "move-tiles": {
          "content": "¡Superfácil! Están diseñados para moverse varias veces sin ningún daño",
          "title": "¿Es fácil cambiarlos de sitio?"
        },
        "photo-books-customize": {
          "content": "¡Sin esfuerzo! Nuestro diseño exclusivo, con una foto por página, garantiza que cada recuerdo preciado tenga el protagonismo que merece. Personaliza tu álbum de fotos eligiendo la foto perfecta para la portada y personaliza tu libro removiendo (¡o eliminando!) el texto. Con solo un clic y arrastrando, puedes centrar tus fotos en cada página o reorganizarlas para contar tu historia tal como la imaginaste.",
          "title": "¿Cómo puedo personalizar mi álbum de fotos?"
        },
        "photo-books-delivery": {
          "content": "Tu álbum de fotos llegará aproximadamente {{delivery_time}} días hábiles después de realizar tu pedido, pero no te preocupes: siempre verás la fecha de entrega estimada en la página de pago antes de finalizar tu pedido. Los pedidos se envían por UPS, ¡y lo mejor es que el envío es totalmente gratis!",
          "title": "¿Cuánto tiempo tarda en llegar mi álbum de fotos?"
        },
        "photo-books-discount": {
          "content": "¡Excelente pregunta! Como los álbumes de fotos son una novedad en nuestra colección, la mayoría de nuestros descuentos Mixtiles aún no se aplican. Sin embargo, si tienes créditos Mixtiles o una tarjeta de regalo regular, ¡puedes usarlos para comprar tu álbum de fotos!",
          "title": "Recibí un descuento para Mixtiles. ¿Puedo aplicarlo a la compra de mi álbum de fotos?"
        },
        "photo-books-material": {
          "content": "Los álbumes de fotos están disponibles exclusivamente en tapa dura, lo que garantiza durabilidad en cada página. La cubierta tiene una fina película mate, mientras que cada página interior está hecha de papel aterciopelado, de tacto sedoso y sin celulosa, que enriquece los colores y reduce los reflejos. Por último, ¡los álbumes de fotos también son reciclables!",
          "title": "¿De qué materiales están hechos los álbumes?"
        },
        "photo-books-shipment": {
          "content": "Actualmente realizamos envíos a Estados Unidos, Canadá, Reino Unido, la Unión Europea y Australia, ¡y esperamos ampliar nuestro servicio a más países en un futuro próximo!",
          "title": "¿A qué países realizan envíos?"
        },
        "photo-books-size": {
          "content": "Los álbumes de fotos están disponibles en tres prácticos tamaños: {{v1}} por {{v1_price}}, {{v2}} por {{v2_price}} y {{v3}} por {{v3_price}}. ¡Independientemente del número de fotos que decidas incluir en tu álbum, el precio seguirá siendo el mismo! Cada álbum de fotos requiere un mínimo de 25 y un máximo de {{max_photos}} fotos de tus recuerdos más preciados.",
          "title": "¿En qué tamaños vienen los álbumes de fotos?"
        },
        "photo-books-size-tiers": {
          "content": "Los álbumes de fotos están disponibles en tres prácticos tamaños: {{v1}} desde {{v1_price}}, {{v2}} desde {{v2_price}} y {{v3}} desde {{v3_price}}. Cada tamaño tiene tres sencillos niveles de precio según el número de páginas: hasta 40, hasta 120 y hasta 200 páginas. Cada álbum de fotos requiere un mínimo de 25 fotos y puede incluir hasta {{max_photos}} de tus recuerdos más preciados.",
          "title": "¿En qué tamaños vienen los álbumes de fotos?"
        },
        "photo-books-wedding-size": {
          "content": "El fotolibro de boda de Mixtiles viene en los siguientes tamaños: {{v1}}, {{v2}} y {{v3}}, para que puedas elegir el perfecto y conservar los recuerdos fotográficos más valiosos de tu gran día.",
          "title": "¿Qué tamaño debo elegir para mi fotolibro de boda?"
        },
        "photo-books-wedding-paper": {
          "content": "En Mixtiles queremos que tu fotolibro de boda dure para siempre, por eso usamos papel aterciopelado con tacto sedoso y una tapa dura con acabado mate que garantiza durabilidad y un acabado profesional.",
          "title": "¿Qué tipo de papel es mejor para un fotolibro de boda?"
        },
        "photo-books-wedding-pages": {
          "content": "El número de páginas de nuestro fotolibro de boda suele depender de cuántas fotos quieras incluir y del nivel de detalle. Un buen punto de partida son entre 20 y 40 páginas, suficiente para una colección completa pero concisa de tus recuerdos de boda.",
          "title": "¿Cuántas páginas debe tener un fotolibro de boda?"
        },
        "photo-books-wedding-durability": {
          "content": "Una impresión de álbum de boda, hecha con materiales de alta calidad y bien conservada, puede durar muchos años, preservando tus recuerdos para futuras generaciones. Es importante mantener el libro alejado de la luz directa del sol y la humedad para asegurar su longevidad.",
          "title": "¿Cuánto dura una impresión de álbum de boda?"
        },
        "photo-books-wedding-vs-traditional": {
          "content": "Crear un fotolibro de boda ofrece una forma moderna y sencilla de mostrar tus recuerdos. Con un proceso de creación de un solo toque, organiza automáticamente las fotos en páginas, listo para pedir al instante. Puedes personalizar el orden si lo deseas, siendo una alternativa práctica y personal a los álbumes tradicionales.",
          "title": "¿Por qué crear un fotolibro de boda en lugar de un álbum tradicional?"
        },
        "photo-books-memory-what-is": {
          "content": "Un fotolibro de recuerdos es una colección bellamente encuadernada de fotografías que captura y preserva tus momentos más queridos. Se usa para reunir y mostrar instantes de reuniones familiares, vacaciones o eventos importantes. Con Mixtiles, puedes crear un fotolibro de recuerdos personalizado que cuente tu historia y te permita revivir tus momentos favoritos en cada página.",
          "title": "¿Qué es un fotolibro de recuerdos y para qué sirve?"
        },
        "photo-books-memory-create": {
          "content": "Crear un fotolibro de recuerdos con Mixtiles es simple e intuitivo. Empieza subiendo un mínimo de 24 fotos y elige hasta {{max_photos}} imágenes para tu libro. Usa nuestras herramientas para organizar, recortar y hacer zoom como prefieras. Cada libro lleva una foto por página para que cada recuerdo brille. Puedes pedir tu fotolibro desde la web o la app.",
          "title": "¿Cómo creo un fotolibro de recuerdos?"
        },
        "photo-books-memory-occasions": {
          "content": "Los fotolibros de recuerdos son perfectos para muchas ocasiones: bodas, cumpleaños, aniversarios, graduaciones y fiestas. También son un detalle especial como libros de homenaje, preservando el legado de seres queridos. Ya sea para celebrar o conmemorar, es una forma atemporal de capturar momentos.",
          "title": "¿Para qué ocasiones sirven los fotolibros de recuerdos?"
        },
        "photo-books-memory-custom": {
          "content": "Crear un fotolibro de recuerdos a medida te permite personalizar tu colección. Con Mixtiles puedes ordenar tus fotos para contar tu historia a tu manera. Nuestros libros de primera calidad, impresos en papel aterciopelado con tacto sedoso y tapa dura mate, combinan durabilidad y elegancia para que sean recuerdos duraderos.",
          "title": "¿Por qué crear un fotolibro de recuerdos personalizado?"
        },
        "photo-books-memory-pages": {
          "content": "Los fotolibros de recuerdos de Mixtiles pueden incluir hasta {{max_photos}} páginas, con una foto por página. Así cada recuerdo destaca por sí mismo, recibiendo la atención que merece.",
          "title": "¿Cuántas páginas puedo incluir en un fotolibro de recuerdos?"
        },
        "photo-books-memory-cover": {
          "content": "Nuestros fotolibros de recuerdos tienen tapa dura con acabado mate, que aporta durabilidad y un toque de elegancia. Puedes elegir una foto especial para la portada y personalizar el texto. La contraportada queda sin foto para un look limpio y sofisticado.",
          "title": "¿Qué opciones de portada hay para los fotolibros de recuerdos?"
        },
        "photo-books-memory-cost": {
          "content": "El precio de un fotolibro de recuerdos Mixtiles varía según el tamaño y el número de páginas. Para precios exactos, visita nuestra web o app, donde podrás explorar opciones y elegir la que más te convenga.",
          "title": "¿Cuánto cuesta un fotolibro de recuerdos?"
        },
        "photo-books-memory-easiest": {
          "content": "La forma más fácil de crear un fotolibro de recuerdos es usando la plataforma intuitiva de Mixtiles. Nuestra web y app te permiten subir, organizar y editar tus fotos en pocos clics. Si necesitas ayuda, nuestro equipo está disponible por chat en vivo o email.",
          "title": "¿Cuál es la forma más fácil de crear un fotolibro de recuerdos?"
        },
        "photo-books-small-sizes": {
          "content": "Ofrecemos tres tamaños para nuestros fotolibros: {{v1}} ({{v1_dimensions}}), {{v2}} ({{v2_dimensions}}) y {{v3}} ({{v3_dimensions}}). El tamaño {{v1}} es ideal para un fotolibro pequeño: compacto y elegante para lucir tus momentos favoritos.",
          "title": "¿En qué tamaños vienen los fotolibros pequeños?"
        },
        "photo-books-small-why-choose": {
          "content": "Un fotolibro pequeño es perfecto si buscas algo portátil y que ocupe poco espacio. Es ideal como recuerdo personal o regalo, y no sacrifica calidad: usamos materiales premium y colores vibrantes.",
          "title": "¿Por qué elegir un fotolibro pequeño en lugar de uno grande?"
        },
        "photo-books-small-occasions": {
          "content": "Los fotolibros pequeños son versátiles y funcionan muy bien para temas como reuniones familiares, viajes o hitos especiales. También son fantásticos para series temáticas, como fotos de tu mascota o el primer año de tu bebé.",
          "title": "¿Qué temas funcionan bien en un fotolibro pequeño?"
        },
        "photo-books-small-pages": {
          "content": "Los fotolibros pequeños de Mixtiles pueden tener entre 24 y {{max_photos}} páginas, con una foto por página. Así creas una colección completa pero concisa en la que cada recuerdo tiene su espacio.",
          "title": "¿Cuántas páginas puede tener un fotolibro pequeño?"
        },
        "photo-books-small-customizable": {
          "content": "¡Claro! En Mixtiles puedes personalizar tu fotolibro pequeño: ordenar, hacer zoom y recortar tus fotos. También puedes elegir una foto especial para la portada y añadir texto personalizado.",
          "title": "¿Se pueden personalizar los fotolibros pequeños?"
        },
        "photo-books-small-gifts": {
          "content": "Sí, los fotolibros pequeños son regalos excelentes. Su tamaño compacto es perfecto para compartir recuerdos con tus seres queridos en cumpleaños, aniversarios o fiestas.",
          "title": "¿Los fotolibros pequeños son buenos como regalo?"
        },
        "photo-books-small-materials": {
          "content": "Los fotolibros pequeños de Mixtiles se fabrican con materiales de alta calidad. Las páginas son de papel aterciopelado, con tacto sedoso y sin madera, que reduce reflejos y realza el color. La tapa dura tiene un elegante acabado mate.",
          "title": "¿Qué materiales y acabados usan los fotolibros pequeños?"
        },
        "photo-books-small-story": {
          "content": "Para contar una historia significativa en tu fotolibro pequeño, elige fotos que sigan tu tema y ordénalas con una progresión clara. Usa nuestras herramientas para ajustar cada imagen y personaliza la portada con un título que resuma tu colección.",
          "title": "¿Cómo hago que un fotolibro pequeño cuente una historia?"
        },
        "photo-books-boudoir-what-is": {
          "content": "Un fotolibro boudoir es una colección personalizada de fotografías íntimas y artísticas para celebrar tu belleza y confianza. En Mixtiles lo encuadernamos y imprimimos en papel premium para que revivas esos momentos en cada página.",
          "title": "¿Qué es un fotolibro boudoir y por qué crearlo?"
        },
        "photo-books-boudoir-select-photos": {
          "content": "Elegir fotos para tu fotolibro boudoir es personal. Elige imágenes que reflejen tu personalidad y la historia que quieres contar, con variedad de poses y expresiones. Con Mixtiles puedes acercar, recortar y reorganizar tus fotos para lograr el look perfecto.",
          "title": "¿Cómo elijo qué fotos boudoir incluir?"
        },
        "photo-books-boudoir-layout": {
          "content": "Al maquetar tu fotolibro boudoir, busca equilibrio entre estética y narrativa. En Mixtiles cada página muestra una foto para que cada recuerdo destaque. Puedes ajustar el orden para crear el flujo que prefieras.",
          "title": "¿Cómo debo disponer las fotos en un fotolibro boudoir?"
        },
        "photo-books-boudoir-size-style": {
          "content": "Ofrecemos tres tamaños para nuestros fotolibros: {{v1}}, {{v2}} y {{v3}}. Elige el que mejor se adapte a tus preferencias y al número de fotos. La tapa dura con acabado mate añade un toque de elegancia, ideal para un fotolibro boudoir.",
          "title": "¿Qué tamaño y estilo elegir para un fotolibro boudoir?"
        },
        "photo-books-boudoir-personalize": {
          "content": "Personalizar tu fotolibro boudoir es muy sencillo con Mixtiles. Añade una foto especial en la portada y personaliza el texto para resumir tu historia, creando un libro único.",
          "title": "¿Cómo puedo personalizar mi fotolibro boudoir?"
        },
        "photo-books-boudoir-cover-materials": {
          "content": "Aunque en Mixtiles ofrecemos una elegante tapa dura con acabado mate, muchos fotolibros boudoir tradicionales usan materiales como cuero o terciopelo para un toque más lujoso. Nuestra tapa dura combina durabilidad y elegancia para que tu libro sea un tesoro atemporal.",
          "title": "¿Qué materiales de portada funcionan bien para libros boudoir?"
        },
        "photo-books-boudoir-color-mix": {
          "content": "Incluir una mezcla de imágenes en color y en blanco y negro aporta profundidad y contraste. El blanco y negro resalta emociones y detalles, mientras que el color añade viveza. Nuestra impresión premium hace que ambos se vean espectaculares.",
          "title": "¿Debo mezclar fotos en color y en blanco y negro?"
        },
        "photo-books-boudoir-order": {
          "content": "Puedes pedir tu fotolibro boudoir desde la web o la app de Mixtiles. Nuestro proceso de creación de un solo toque facilita subir y organizar tus fotos. Si necesitas ayuda, estamos disponibles por email o chat en vivo.",
          "title": "¿Dónde puedo pedir un fotolibro boudoir?"
        },
        "photo-books-travel-why-make": {
          "content": "Crear un fotolibro de viaje es una forma preciosa de preservar y revivir tus aventuras. En Mixtiles, nuestros fotolibros personalizados capturan la esencia de tus recorridos. A diferencia de los álbumes digitales, un libro físico ofrece una experiencia más cercana.",
          "title": "¿Por qué hacer un fotolibro de viaje?"
        },
        "photo-books-travel-features": {
          "content": "Nuestros fotolibros de viaje permiten añadir detalles que enriquecen tu historia: mapas, itinerarios, pies de foto y notas personales. Con Mixtiles tienes libertad creativa para organizar fotos y texto como mejor represente tu aventura.",
          "title": "¿Qué características puedo añadir a un fotolibro de viaje?"
        },
        "photo-books-travel-cropping": {
          "content": "En Mixtiles priorizamos la facilidad de uso. Puedes recortar y reorganizar fotos fácilmente. Cada libro usa un diseño de una foto por página para que cada recuerdo tenga protagonismo y el álbum se vea limpio y elegante.",
          "title": "¿Cómo gestionan el recorte y los diseños en fotolibros de viaje?"
        },
        "photo-books-travel-details": {
          "content": "Puedes incluir pies de foto, fechas, ubicaciones e incluso fragmentos de tu itinerario. Estos detalles ayudan a contar la historia detrás de cada imagen y enriquecen tu fotolibro de viaje.",
          "title": "¿Qué detalles de viaje puedo incluir en mi fotolibro?"
        },
        "photo-books-travel-structure": {
          "content": "Estructurar tu fotolibro de viaje es sencillo: portada llamativa, una página introductoria y organiza las fotos por cronología o por temas (paisajes, cultura, gastronomía). Usa pies de foto breves para guiar al lector.",
          "title": "¿Cómo estructuro un fotolibro de viaje para contar una historia?"
        },
        "photo-books-travel-quality": {
          "content": "Sí, los fotolibros de viaje de Mixtiles están hechos con materiales premium: papel aterciopelado con tacto sedoso que minimiza reflejos y realza el color, y tapa dura mate para proteger tu libro. Además, usamos materiales ecológicos.",
          "title": "¿Los fotolibros de viaje son de alta calidad y duraderos?"
        },
        "photo-books-travel-services": {
          "content": "Mixtiles ofrece una plataforma fácil con proceso de creación de un toque. Al subir tus fotos, las organizamos en un libro listo para pedir que puedes personalizar. Disponemos de tres tamaños para adaptarse a tus preferencias.",
          "title": "¿Qué tipos de plantillas o servicios hay para fotolibros de viaje?"
        },
        "photo-books-travel-relive": {
          "content": "Un fotolibro de viaje Mixtiles es más que imágenes: te hace revivir cada aventura al pasar las páginas y compartir tus historias con los tuyos. Tus recuerdos quedan preservados en un formato bello y tangible.",
          "title": "¿Cómo me ayuda un fotolibro de viaje a revivir mis aventuras?"
        },
        "photo-books-coffee-table-what-is": {
          "content": "Un fotolibro de mesa es un libro cuidadosamente diseñado para lucir tus fotos favoritas e invitar a hojearlas. En Mixtiles los transformamos en historias visuales personalizadas que decoran cualquier sala.",
          "title": "¿Qué es un fotolibro de mesa y por qué hacerlo?"
        },
        "photo-books-coffee-table-themes": {
          "content": "Temas como familia, viajes, bodas o un resumen del año funcionan de maravilla. Con Mixtiles puedes crear un fotolibro de mesa a tu medida gracias a nuestra plataforma fácil de usar.",
          "title": "¿Qué temas funcionan bien para un fotolibro de mesa?"
        },
        "photo-books-coffee-table-design": {
          "content": "Diseñar un fotolibro de mesa es sencillo: sube y ordena tus fotos. Usamos una foto por página para que cada imagen brille. Puedes acercar, recortar y reorganizar para crear una narrativa fluida.",
          "title": "¿Cómo diseño un fotolibro de mesa atractivo (diseño y contenido)?"
        },
        "photo-books-coffee-table-travel-wedding": {
          "content": "¡Por supuesto! Las fotos de viajes y bodas son perfectas para fotolibros de mesa: son visuales y emotivas. Con páginas de tacto sedoso y tapa dura mate, tus recuerdos se verán con la máxima calidad.",
          "title": "¿Debo incluir fotos de viajes o bodas en un fotolibro de mesa?"
        },
        "photo-books-coffee-table-gifts": {
          "content": "Sí, los fotolibros de mesa son regalos personales, atentos y atemporales. Ideales para cumpleaños, aniversarios u otros hitos.",
          "title": "¿Los fotolibros de mesa son buenos regalos?"
        },
        "photo-books-coffee-table-year-review": {
          "content": "Un fotolibro de mesa \"año en fotos\" reúne los momentos más memorables del año. Con Mixtiles, puedes mostrar hasta {{max_photos}} recuerdos en un volumen elegante.",
          "title": "¿Qué es un fotolibro de mesa de resumen del año?"
        },
        "photo-books-coffee-table-guest-house": {
          "content": "Los fotolibros de mesa son ideales para casas de huéspedes o salas de espera: crean un ambiente acogedor y entretienen a los visitantes con fotos de la zona, historia local o imágenes bellas.",
          "title": "¿Cómo usar fotolibros de mesa en una casa de huéspedes o sala de espera?"
        },
        "photo-books-coffee-table-suitable": {
          "content": "Un fotolibro apto para la mesa combina atractivo visual, durabilidad y significado. En Mixtiles lo logramos con materiales premium, diseño elegante y personalización para contar tu historia.",
          "title": "¿Qué hace que un fotolibro sea ideal para una mesa?"
        },
        "photo-books-engagement-what-is": {
          "content": "Un fotolibro de compromiso es una colección encuadernada de fotos que capturan los momentos previos a la boda. En Mixtiles lo imprimimos en papel de tacto sedoso con tapa dura mate para un recuerdo hermoso y duradero.",
          "title": "¿Qué es un fotolibro de compromiso y por qué crearlo?"
        },
        "photo-books-engagement-photos-include": {
          "content": "Incluye una variedad que refleje vuestra relación: fotos espontáneas, la sesión de compromiso y momentos especiales. Con Mixtiles puedes recortar, acercar y reorganizar para que cada página encaje perfecto.",
          "title": "¿Qué fotos debo incluir en un fotolibro de compromiso?"
        },
        "photo-books-engagement-proposal": {
          "content": "¡Claro! Incluir las fotos de la pedida de mano es una forma preciosa de recordar el momento del \"sí\". Estas imágenes marcan el inicio de la historia en tu álbum de compromiso.",
          "title": "¿Debo incluir las fotos de la pedida en el libro?"
        },
        "photo-books-engagement-party": {
          "content": "Las fotos de la fiesta de compromiso son un gran añadido: capturan la celebración con familia y amigos. Con Mixtiles puedes incluir hasta {{max_photos}} fotos, con espacio de sobra para esos recuerdos.",
          "title": "¿Incluyo fotos de la fiesta de compromiso?"
        },
        "photo-books-engagement-vs-wedding": {
          "content": "Los fotolibros de compromiso se centran en el camino hasta la boda (propuesta, celebraciones y momentos cotidianos). Los de boda suelen documentar el día de la boda en sí.",
          "title": "¿En qué se diferencian los fotolibros de compromiso y de boda?"
        },
        "photo-books-engagement-cover-styles": {
          "content": "En Mixtiles ofrecemos tapa dura con acabado mate: elegante y resistente. Elige una foto especial para la portada y personaliza el lomo con texto para resumir vuestra historia.",
          "title": "¿Qué estilos y materiales de portada hay para un libro de compromiso?"
        },
        "photo-books-engagement-story": {
          "content": "Tu fotolibro de compromiso puede narrar el viaje desde la propuesta hasta la boda con una selección cuidada y un orden que refleje esa progresión. Nuestra plataforma te ayuda a organizarlo sin esfuerzo.",
          "title": "¿Cómo puede un libro de compromiso contar la historia del \"sí\" a la boda?"
        },
        "photo-books-engagement-keepsake": {
          "content": "Sí, un fotolibro de compromiso es un recuerdo precioso e incluso puede usarse como libro de firmas en la boda. La calidad Mixtiles garantiza un recuerdo que durará años.",
          "title": "¿Sirve como recuerdo o libro de firmas en la boda?"
        },
        "photo-books-family-why-create": {
          "content": "Crear un fotolibro familiar te permite preservar recuerdos en un formato tangible. En Mixtiles es fácil reunir vuestros mejores momentos en un libro personalizado que podrás hojear y revivir.",
          "title": "¿Por qué crear un fotolibro familiar?"
        },
        "photo-books-family-formats": {
          "content": "Nuestros fotolibros son ideales para fotos familiares por su calidad y personalización. Ofrecemos tres tamaños: {{v1}}, {{v2}} y {{v3}}. Cada libro usa una foto por página para que cada recuerdo brille.",
          "title": "¿Qué formatos de fotolibro son mejores para fotos familiares?"
        },
        "photo-books-family-organize": {
          "content": "Organizar un fotolibro familiar con Mixtiles es simple: sube y ordena tus fotos para contar vuestra historia. Recorta y ajusta el encuadre, y usa nuestro proceso de creación de un toque para empezar rápido.",
          "title": "¿Cómo organizo un fotolibro familiar?"
        },
        "photo-books-family-memories": {
          "content": "Incluye momentos cotidianos y ocasiones especiales: vacaciones, fiestas, cumpleaños y fotos espontáneas que capturen la esencia de tu familia.",
          "title": "¿Qué recuerdos familiares debo incluir?"
        },
        "photo-books-family-pages": {
          "content": "Nuestros fotolibros pueden mostrar entre 24 y {{max_photos}} fotos, cada una en su propia página. Elige entre un anuario conciso o una colección amplia, según prefieras.",
          "title": "¿Cuántas páginas puede tener un fotolibro familiar?"
        },
        "photo-books-family-cover-size": {
          "content": "Los fotolibros Mixtiles tienen tapa dura mate y tres tamaños: {{v1}}, {{v2}} o {{v3}}, para que elijas el que mejor se adapte a tu estilo.",
          "title": "¿Qué opciones de portada y tamaño hay para fotolibros familiares?"
        },
        "photo-books-family-durable": {
          "content": "Usamos papel de tacto sedoso y una cubierta con film mate que aumenta la durabilidad. Así tu fotolibro familiar será un recuerdo que dure años. Además, son ecológicos y reciclables.",
          "title": "¿Cómo hacer que un fotolibro familiar dure mucho?"
        },
        "photo-books-family-story": {
          "content": "Para tejer la historia de tu familia, añade pies de foto o anécdotas junto a las imágenes. En Mixtiles puedes personalizar la portada con una foto especial y texto que resuma vuestra historia.",
          "title": "¿Cómo incorporar la historia de mi familia en el fotolibro?"
        },
        "photo-books-yearly-what-is": {
          "content": "Un libro de fotos anual es una forma maravillosa de recapitular los recuerdos del año, capturando la esencia de tus experiencias y logros. En Mixtiles, te ofrecemos una manera sencilla de reunir estos momentos especiales en un libro bellamente encuadernado, permitiéndote reflexionar y compartir tu repaso del año con tus seres queridos.",
          "title": "¿Para qué sirve un libro de fotos anual?"
        },
        "photo-books-yearly-gather-photos": {
          "content": "Para crear un completo libro de fotos anual, empieza organizando tus fotos por mes o por eventos importantes. Este método facilita seleccionar las imágenes que mejor representan cada parte de tu año. Nuestra plataforma te permite subir y organizar estas fotos fácilmente, asegurando que tu álbum cuente una historia coherente.",
          "title": "¿Cómo reúno fotos para un álbum anual?"
        },
        "photo-books-yearly-what-include": {
          "content": "Incluye tus experiencias favoritas y conexiones del último año. Ya sean reuniones familiares, vacaciones o logros personales, nuestros libros de fotos le dan a cada recuerdo el protagonismo que merece. Con las sencillas herramientas de edición de Mixtiles, puedes hacer zoom, recortar y reorganizar tus fotos para que encajen perfectamente en tu narrativa.",
          "title": "¿Qué debo incluir en un libro de fotos anual?"
        },
        "photo-books-yearly-themes-layouts": {
          "content": "Una línea de tiempo cronológica es un tema muy efectivo para un libro de fotos anual. Te permite mostrar la evolución de tu año, destacando los momentos clave en orden. Nuestros libros de fotos tienen un diseño de una foto por página, lo que garantiza claridad y enfoque en cada recuerdo.",
          "title": "¿Qué temas o diseños funcionan para un libro anual?"
        },
        "photo-books-yearly-formats": {
          "content": "Ofrecemos tres tamaños prácticos para nuestros libros de fotos: {{v1}}, {{v2}} y {{v3}}. Cada tamaño está pensado para diferentes preferencias, desde lo discreto y elegante hasta lo grande y llamativo. En Mixtiles, garantizamos que tu libro de fotos anual esté hecho con materiales de primera calidad, incluyendo una tapa dura mate y páginas con textura sedosa.",
          "title": "¿Qué formatos están disponibles para los libros de fotos anuales?"
        },
        "photo-books-yearly-personalize-cover": {
          "content": "Personalizar la portada de tu libro es muy sencillo con Mixtiles. Elige una foto especial para la portada y añade un título en foil personalizado que resuma tu historia. Este detalle convierte tu libro anual en algo único y fiel a tus experiencias.",
          "title": "¿Cómo puedo personalizar la portada de un libro de fotos anual?"
        },
        "photo-books-yearly-why-make": {
          "content": "Crear un libro de fotos anual transforma los mejores momentos del año en una cápsula de recuerdos. Es una forma tangible de preservar lo que más importa, permitiéndote revivirlo en cualquier momento. Nuestros libros están diseñados para durar, convirtiéndose en un recuerdo resistente para muchos años.",
          "title": "¿Por qué hacer un libro de fotos anual?"
        },
        "photo-books-yearly-how-often": {
          "content": "Recomendamos crear un libro de fotos anual cada año para capturar y conservar tus mejores momentos. Esta tradición te permite construir una colección de recuerdos que podrás mirar con cariño en el futuro. Con Mixtiles, el proceso es fácil y divertido, garantizando que cada libro sea tan especial como los recuerdos que guarda.",
          "title": "¿Con qué frecuencia debo hacer un libro de fotos anual?"
        },
        "photo-books-valentines-great-gift": {
          "content": "Un libro de fotos es el regalo perfecto para San Valentín porque captura tu historia de amor en una forma tangible. En Mixtiles, ofrecemos libros de fotos bellamente encuadernados que te permiten hojear páginas llenas de recuerdos especiales, convirtiéndolos en un detalle lleno de corazón. Nuestros libros de primera calidad, impresos en papel sedoso y aterciopelado, hacen que tus fotos cobren vida con colores vibrantes, dejando una huella duradera de tu amor.",
          "title": "¿Por qué un libro de fotos es un gran regalo de San Valentín?"
        },
        "photo-books-valentines-unique-ideas": {
          "content": "Una idea original es crear un libro de fotos con el tema \"Razones por las que te amo\". Reúne fotos de momentos especiales y acompáñalas con notas o mensajes que expresen por qué valoras a tu pareja. Este toque personal convierte una simple colección de fotos en una narrativa significativa que muestra la profundidad de tu relación.",
          "title": "¿Qué ideas originales puedo usar para un libro de San Valentín?"
        },
        "photo-books-valentines-style": {
          "content": "Para un estilo clásico y atemporal, considera hacer tu libro de San Valentín solo con fotos en blanco y negro. Este enfoque añade elegancia y sofisticación, resaltando las emociones de cada imagen. Con Mixtiles, puedes editar fácilmente tus fotos para lograr este efecto, creando un libro que sea a la vez elegante y personal.",
          "title": "¿Cómo puedo darle estilo a mi libro de San Valentín?"
        },
        "photo-books-valentines-wedding-photos": {
          "content": "¡Por supuesto! Incluir fotos de tu boda en un libro de San Valentín es una forma maravillosa de revivir uno de los momentos más románticos de tu vida. Nuestros libros de fotos muestran una foto por página, dando a cada recuerdo el protagonismo que merece. Es ideal para destacar los mejores momentos de tu boda junto a otros recuerdos especiales.",
          "title": "¿Puedo incluir fotos de boda en un libro de San Valentín?"
        },
        "photo-books-valentines-focus": {
          "content": "Concéntrate en capturar momentos románticos y recuerdos que definan tu relación. Puede ser tu primera cita, unas vacaciones inolvidables o incluso fotos espontáneas del día a día. Estas imágenes cuentan la historia de tu amor. Nuestras herramientas de edición te permiten organizar y personalizar tus fotos, asegurando que tu libro de San Valentín refleje tu viaje único como pareja.",
          "title": "¿En qué debo enfocarme en un libro de San Valentín?"
        },
        "photo-books-valentines-fun-personal": {
          "content": "Combina fotos espontáneas y posadas para crear un libro divertido y personal. Las fotos naturales capturan emociones genuinas y momentos espontáneos, mientras que las posadas destacan ocasiones especiales. Con el proceso de creación con un solo toque de Mixtiles, es muy fácil organizar tus fotos y añadir detalles personales que hagan tu libro verdaderamente único.",
          "title": "¿Cómo hago que el libro sea divertido y personal?"
        },
        "photo-books-valentines-suitable-couples": {
          "content": "Sí, un libro de San Valentín es adecuado para cualquier pareja, ya sean recién casados o lleven años juntos. Es un regalo versátil que celebra su camino en común, capturando tanto recuerdos recientes como antiguos. Nuestros libros de fotos ofrecen un diseño elegante y resistente que se adapta a todas las etapas de una relación.",
          "title": "¿Es un libro de San Valentín adecuado para cualquier pareja?"
        },
        "photo-books-valentines-gather-content": {
          "content": "Reúne el contenido recopilando notas de amor, tus fotos favoritas y frases significativas que resuman tu relación. Crea un álbum en tu dispositivo para guardarlas y tenerlas listas cuando armes tu libro. Recomendamos subir un mínimo de 24 fotos para crear un libro de San Valentín completo y con mucho corazón.",
          "title": "¿Cómo reúno contenido para un álbum de San Valentín?"
        },
        "shipping-location": {
          "content": "¡Sí, a la mayoría de los países del mundo!",
          "title": "¿Hacen envíos internacionales?"
        },
        "shipping-time": {
          "content": "Una semana, más o menos. Hay opciones de envío exprés disponibles en algunos países. Te enviaremos un número de seguimiento después de tu compra",
          "title": "¿Cuánto tarda el envío?"
        },
        "title": "Preguntas Frecuentes",
        "walls": {
          "content": "No, sin daños",
          "title": "¿Y no dañarán mis paredes?"
        },
        "photo-books-graduation-why-create": {
          "content": "Crear un libro de fotos de graduación es una forma maravillosa de preservar recuerdos clave de una etapa importante de la vida. En Mixtiles, ofrecemos libros de fotos bellamente encuadernados que te permiten seleccionar y revivir esos momentos tan especiales. Nuestros libros funcionan como recuerdos personalizados que capturan la alegría y los logros del día de la graduación, ofreciendo un recordatorio tangible de tus éxitos.",
          "title": "¿Por qué debería crear un libro de fotos de graduación?"
        },
        "photo-books-graduation-what-photos": {
          "content": "Un buen libro de fotos de graduación debe incluir una variedad de imágenes: la emoción del primer día, el orgullo de la ceremonia, momentos espontáneos con amigos y eventos memorables a lo largo del año escolar. En conjunto, estas fotos cuentan la historia de tu recorrido, destacando tu crecimiento personal y tus logros.",
          "title": "¿Qué fotos debo incluir en un álbum de graduación?"
        },
        "photo-books-graduation-organize": {
          "content": "Puedes organizar tus fotos de graduación de forma cronológica o por temas. En Mixtiles, te facilitamos ordenar tus fotos exactamente como quieras. Ya sea que prefieras mostrar el viaje de principio a fin o agrupar por eventos o amistades, nuestras herramientas de edición sencillas te permiten personalizar tu libro para reflejar tu historia única.",
          "title": "¿Cómo debo organizar las fotos?"
        },
        "photo-books-graduation-how-many-photos": {
          "content": "Para un libro de graduación de Mixtiles, necesitas al menos 24 fotos y puedes incluir hasta {{max_photos}}. Reúne las imágenes desde tus dispositivos, redes sociales o amigos que hayan capturado momentos especiales. Esta selección garantizará una representación completa y vibrante de tu experiencia de graduación.",
          "title": "¿Cuántas fotos necesito y dónde las encuentro?"
        },
        "photo-books-graduation-design-theme": {
          "content": "Elegir un tema de diseño para tu libro de graduación depende de tu estilo personal y de la historia que quieras contar. Nuestros libros cuentan con una elegante tapa dura mate e impresión en papel aterciopelado con tacto sedoso, mejorando tanto el aspecto como la sensación de tus recuerdos. Elijas un estilo clásico y elegante o algo más moderno y colorido, nos aseguramos de que tus fotos cobren vida con color intenso y calidad premium.",
          "title": "¿Qué tema de diseño debo elegir para mi libro de graduación?"
        },
        "photo-books-graduation-quotes-messages": {
          "content": "Sí, puedes personalizar tu libro de graduación incluyendo citas o mensajes que conecten con tu recorrido. Aunque no ofrecemos una función dedicada para generar códigos QR, puedes crearlos externamente y subirlos como imagen. Así podrás añadir elementos interactivos a tu libro y aumentar su valor personal.",
          "title": "¿Puedo incluir citas, mensajes o códigos QR?"
        },
        "photo-books-graduation-sort-upload": {
          "content": "Clasificar y subir tus fotos de graduación con Mixtiles es pan comido. Nuestro proceso de creación con un toque organiza tus fotos en páginas, dejando el libro listo para pedir. Luego puedes personalizar y ordenar para que cada página refleje tu toque personal.",
          "title": "¿Cómo clasifico y subo mis fotos de graduación?"
        },
        "photo-books-graduation-templates-layouts": {
          "content": "Nuestros libros de fotos tienen una sola disposición con una foto por página, para que cada recuerdo tenga el foco que merece. Este diseño simple pero efectivo permite que cada imagen destaque, ideal para capturar la esencia de tu recorrido de graduación. Con nuestras herramientas fáciles, puedes recortar y reorganizar las fotos para adaptarlas a la historia que quieras contar.",
          "title": "¿Qué plantillas o diseños funcionan bien para un libro de graduación?"
        },
        "photo-books-birthday-important-moments": {
          "content": "Capturar la esencia de un cumpleaños en un libro de fotos implica enfocarse en momentos clave como cortar el pastel, abrir los regalos y las interacciones con los invitados. Estos instantes resaltan la alegría y la emoción del día, y son esenciales para un libro completo. En Mixtiles, nuestros libros te permiten revivir esos recuerdos con cada pasada de página.",
          "title": "¿Qué momentos son importantes capturar en un libro de cumpleaños?"
        },
        "photo-books-birthday-photograph-party": {
          "content": "Para crear un libro de cumpleaños espectacular, combina planos generales y primeros planos. Captura toda la sala para ambientar la escena y acércate a detalles como la decoración y las expresiones. Nuestros libros, impresos en papel aterciopelado con tacto sedoso, hacen que cada foto —de lo general a lo más mínimo— brille con color vibrante.",
          "title": "¿Cómo fotografío una fiesta de cumpleaños para lograr un gran libro de fotos?"
        },
        "photo-books-birthday-candid-vs-posed": {
          "content": "Las fotos posadas tienen su lugar, pero las espontáneas suelen capturar la alegría y la espontaneidad reales de una fiesta. Enfócate en risas, sorpresas e interacciones para un retrato más auténtico. Con las herramientas de edición de Mixtiles, puedes organizar estos momentos para crear una narrativa que refleje el espíritu de la celebración.",
          "title": "¿Debo enfocarme en fotos espontáneas o posadas?"
        },
        "photo-books-birthday-details-include": {
          "content": "Incluye detalles como la decoración, el pastel y las sonrisas de los asistentes para aportar profundidad a tu libro. Estos elementos ayudan a dibujar un panorama completo del evento y convierten tu libro en un recuerdo vibrante. Nuestros libros personalizables te permiten destacar cada detalle con la disposición de una foto por página.",
          "title": "¿Qué detalles debería incluir?"
        },
        "photo-books-birthday-tell-story": {
          "content": "Para que tus fotos cuenten una historia, ordénalas cronológicamente: desde la llegada de los invitados hasta las despedidas. Esta secuencia narra de forma natural el día. En Mixtiles, nuestro proceso con un toque organiza tus fotos en un relato coherente, con opción de personalización adicional.",
          "title": "¿Cómo aseguro que las fotos del cumpleaños cuenten una historia?"
        },
        "photo-books-birthday-angle-focus": {
          "content": "Tener un tema o foco —como una paleta de colores o un motivo de la fiesta— puede darle un ángulo único a tu libro. Este enfoque guía la selección y el orden de las fotos, creando un libro más atractivo y coherente. La tapa dura mate de nuestros libros complementa cualquier tema y añade elegancia a tu recuerdo personalizado.",
          "title": "¿Es útil tener un \"ángulo\" o foco para el evento?"
        },
        "photo-books-birthday-subjects-interest": {
          "content": "Temas como juegos, atuendos especiales e interacciones únicas entre invitados generan interés en cada página. Aportan variedad y emoción, haciendo que cada pasada sea una sorpresa agradable. Con los libros de calidad premium de Mixtiles, cada foto tiene su protagonismo y tus recuerdos se conservan de forma hermosa.",
          "title": "¿Qué temas crean interés en cada página?"
        },
        "photo-books-birthday-how-many-photos": {
          "content": "Para un libro equilibrado, incluye entre 50 y 100 fotos. Este rango te permite cubrir todo el evento sin abrumar. Los libros de Mixtiles admiten hasta 150 fotos, dándote flexibilidad para incluir tus momentos favoritos manteniendo un diseño limpio y organizado.",
          "title": "¿Cuántas fotos debería incluir de la fiesta?"
        },
        "photo-books-retirement-how-create": {
          "content": "Crear un libro de fotos de jubilación con Mixtiles es sencillo y agradable. Empieza subiendo un mínimo de 24 fotos en nuestra web o app, mostrando hasta {{max_photos}} recuerdos. Nuestra plataforma intuitiva organiza las imágenes automáticamente, pero puedes personalizar la disposición para contar una historia única. Cada página presenta una foto para que cada momento brille. Con nuestro papel de calidad premium, aterciopelado y de tacto sedoso, y la elegante tapa dura mate, tu libro será un recuerdo precioso para tu colega o ser querido.",
          "title": "¿Cómo creo un libro de fotos de jubilación para un colega o ser querido?"
        },
        "photo-books-retirement-when-start-planning": {
          "content": "Recomendamos empezar al menos con un mes de antelación. Así tendrás tiempo de reunir fotos significativas y aportes de los compañeros, asegurando un libro completo y emotivo. Planificar con tiempo también te permite aprovechar nuestras funciones de edición para ordenar y personalizar a la perfección. Recuerda: puedes guardar temporalmente tus selecciones y finalizar tu obra maestra cuando estés listo.",
          "title": "¿Cuándo debería empezar a planificar un libro de jubilación?"
        },
        "photo-books-retirement-types-photos": {
          "content": "Un libro de jubilación debe captar la esencia de la carrera y la personalidad del homenajeado. Incluye una mezcla de hitos —proyectos, premios y ascensos— junto con momentos espontáneos en la oficina que reflejen las interacciones diarias y amistades. Nuestros libros te permiten recortar y organizar imágenes para que cada foto encaje con la narrativa que quieres crear.",
          "title": "¿Qué tipos de fotos debería incluir?"
        },
        "photo-books-retirement-coworkers-contribute": {
          "content": "¡Por supuesto! Invitar a los compañeros a aportar fotos y mensajes añade profundidad y calidez. Es una gran forma de incluir perspectivas y recuerdos diversos. En Mixtiles fomentamos la colaboración y nuestra plataforma facilita subir y organizar contribuciones de múltiples fuentes.",
          "title": "¿Debo pedir a los compañeros que aporten fotos y mensajes?"
        },
        "photo-books-retirement-humor-personal-touches": {
          "content": "Añadir humor y toques personales puede hacer tu libro realmente especial. Considera incluir consejos graciosos, chistes de oficina o frases memorables de la carrera del homenajeado. También puedes incorporar fotos de recuerdos de la oficina o eventos significativos. Nuestras opciones de personalización te permiten editar texto e imágenes fácilmente para integrar perfectamente tus aportes.",
          "title": "¿Cómo puedo añadir humor o toques personales?"
        },
        "photo-books-retirement-layout-ideas": {
          "content": "Una línea de tiempo de los hitos de la carrera es una forma fantástica de estructurar el libro. Empieza con los inicios y avanza hasta la jubilación, resaltando logros y transiciones. Con nuestra disposición de una foto por página, cada hito recibe la atención que merece, y puedes reorganizar con facilidad para crear una narrativa coherente.",
          "title": "¿Qué ideas de diseño pueden hacerlo especial?"
        },
        "photo-books-retirement-photo-quality": {
          "content": "La calidad de las fotos es clave para un libro impresionante. Recomendamos imágenes con resolución entre 600 × 600 y 7000 × 7000 píxeles para asegurar nitidez y viveza. Nuestra plataforma te avisará si alguna foto no cumple estos estándares, para que puedas elegir la mejor opción.",
          "title": "¿Qué tan importante es la calidad de las fotos para un álbum de jubilación?"
        },
        "photo-books-retirement-meaningful-gifts": {
          "content": "Los libros de jubilación son regalos significativos porque condensan el recorrido profesional y los vínculos personales del homenajeado. Ofrecen una forma tangible de recordar logros y momentos entrañables. En Mixtiles, nos aseguramos de que tu libro sea un recuerdo premium y personalizado que se atesorará por años.",
          "title": "¿Por qué los libros de jubilación son regalos con significado?"
        },
        "photo-books-fathers-day-great-gift": {
          "content": "Un libro de fotos es un regalo fantástico para el Día del Padre porque captura recuerdos especiales y momentos personales que celebran su historia única. Ofrecemos libros bellamente encuadernados para reunir momentos en familia, viajes y hitos en un recuerdo que Papá podrá atesorar siempre. Están hechos con materiales de alta calidad, para un regalo duradero y elegante.",
          "title": "¿Por qué un libro de fotos es un gran regalo para el Día del Padre?"
        },
        "photo-books-fathers-day-memories-include": {
          "content": "Incluye una mezcla de recuerdos que destaquen distintas facetas de la vida de tu padre: fotos de bebé, viajes familiares y eventos importantes. Nuestros libros presentan una foto por página, asegurando que cada recuerdo tenga su protagonismo. Con nuestras herramientas, puedes recortar y organizar para contar tu historia a la perfección.",
          "title": "¿Qué recuerdos debería incluir?"
        },
        "photo-books-fathers-day-make-special": {
          "content": "Para hacerlo aún más especial, prueba con un tema \"Antes y Ahora\". Empieza con fotos de la infancia y avanza por los grandes momentos, terminando con reuniones recientes o logros actuales. También puedes personalizar la portada con una foto significativa y un texto que resuma tu historia. En Mixtiles, te lo ponemos fácil para crear un recuerdo que Papá apreciará.",
          "title": "¿Cómo puedo hacer el libro especial para Papá?"
        },
        "photo-books-fathers-day-involve-children": {
          "content": "Involucrar a los niños añade un toque muy emotivo. Anímalos a aportar dibujos o a escribir notas cortas que puedas escanear e incluir. Además de personalizar el regalo, lo convierte en un proyecto familiar. En Mixtiles, apoyamos tu creatividad para que diseñes un libro único para el Día del Padre.",
          "title": "¿Debería involucrar a los niños en la creación del libro?"
        },
        "photo-books-fathers-day-format-recommended": {
          "content": "Nuestros libros tienen una elegante tapa dura mate que ofrece durabilidad y estilo. A diferencia de los álbumes tradicionales de cuero o tapas blandas, imprimimos en papel aterciopelado de tacto sedoso que reduce reflejos y mantiene los colores vivos. Un acabado premium para conservar tus recuerdos de forma impecable.",
          "title": "¿Qué formato se recomienda?"
        },
        "photo-books-fathers-day-who-book-for": {
          "content": "Un libro del Día del Padre es un regalo versátil para papás primerizos, abuelos y cualquier figura paterna. Ya sea para celebrar el primer Día del Padre o para honrar años de paternidad, nuestros libros se adaptan a la historia de cualquier papá. Con tamaños de {{v1}} a {{v3}}, puedes elegir el formato perfecto para tu destinatario.",
          "title": "¿Para quién es este libro?"
        },
        "photo-books-fathers-day-how-many-photos": {
          "content": "Nuestros libros pueden incluir entre 24 y {{max_photos}} fotos, con una imagen por página. Esta flexibilidad te permite crear una colección amplia o concisa, según prefieras.",
          "title": "¿Cuántas fotos o páginas incluir?"
        },
        "photo-books-fathers-day-nostalgic-photos": {
          "content": "¡Claro! Las fotos familiares nostálgicas son perfectas para el libro del Día del Padre. Nuestra plataforma permite subir imágenes con una resolución mínima de 600 × 600 píxeles para asegurar nitidez. Revive esos recuerdos con nuestras impresiones de calidad premium.",
          "title": "¿Puedo usar fotos familiares antiguas en el libro del Día del Padre?"
        },
        "photo-books-pet-dog-create-personalized": {
          "content": "¡Crear un álbum personalizado de tu perro con Mixtiles es facilísimo! Sube tus fotos favoritas a nuestra web o app y nuestra plataforma las organizará automáticamente en un libro impresionante. Luego puedes personalizar reordenando, recortando y añadiendo toques personales. Imprimimos en papel aterciopelado de tacto sedoso con una resistente tapa dura mate, para que tus recuerdos duren toda la vida.",
          "title": "¿Cómo creo un álbum de fotos personalizado para mi perro?"
        },
        "photo-books-pet-dog-photos-include": {
          "content": "Al crear el álbum de tu perro, intenta capturar momentos variados que muestren su personalidad y lo que comparten. Incluye travesuras diarias, juegos y esos ratos tranquilos que reflejan su carácter único. Nuestra plataforma permite subir entre 24 y {{max_photos}} fotos, dándote espacio de sobra para contar tu historia.",
          "title": "¿Qué fotos debo incluir en el álbum de mi perro?"
        },
        "photo-books-pet-dog-puppy-family-photos": {
          "content": "¡Por supuesto! Incluir fotos de cachorro junto con fotos familiares crea una narrativa entrañable. Te animamos a mezclar diferentes etapas de la vida de tu mascota con hitos familiares para un recuerdo completo que celebre a tu peludo como parte de la familia.",
          "title": "¿Puedo incluir fotos de cuando era cachorro y fotos familiares?"
        },
        "photo-books-pet-dog-choose-best-photos": {
          "content": "Para elegir las mejores fotos, prioriza imágenes de alta calidad que emocionen y cuenten algo. Asegúrate de que cumplan nuestra resolución recomendada de 600 × 600 a 7000 × 7000 píxeles para una impresión óptima. También puedes usar nuestras herramientas para recortar y mejorar, y así lograr páginas perfectas.",
          "title": "¿Cómo elijo las mejores fotos de mi perro para el álbum?"
        },
        "photo-books-pet-dog-why-make-album": {
          "content": "Hacer un álbum de tu perro es una forma preciosa de celebrar y preservar el vínculo especial que comparten. Es un recuerdo personal para revivir momentos y hitos. Ya sea en tu mesa de centro o para compartir con tus seres queridos, es una manera significativa de honrar su lugar en tu vida.",
          "title": "¿Por qué hacer un álbum de fotos para mi perro?"
        },
        "photo-books-pet-dog-templates-design-ideas": {
          "content": "Aunque Mixtiles no ofrece plantillas específicas, nuestro proceso de creación con un toque simplifica el diseño de tu álbum. Una vez subidas, las fotos se organizan automáticamente en una disposición limpia que puedes personalizar. Así tu creatividad brilla y el álbum refleja tu estilo y la historia única de tu perro.",
          "title": "¿Hay plantillas o ideas de diseño para un álbum de perro?"
        },
        "photo-books-pet-dog-include-milestones": {
          "content": "Incluir hitos como su \"primer paseo\" o la \"primera Navidad\" aporta profundidad y significado. Estos eventos resaltan su crecimiento y las experiencias compartidas. Ofrecemos una foto por página para que cada hito tenga su propio protagonismo.",
          "title": "¿Debo incluir fotos de hitos como \"primer paseo\" o \"primera Navidad\"?"
        },
        "photo-books-pet-dog-gift-idea": {
          "content": "Sí, un álbum personalizado de tu perro es un regalo original y muy considerado para cualquier amante de las mascotas. Al finalizar la compra, puedes pedir varias copias idénticas al original para compartir tus recuerdos con familia y amigos.",
          "title": "¿Puedo usar el álbum de mi perro como regalo para un amante de las mascotas?"
        },
        "photo-books-anniversary-great-gift": {
          "content": "Un libro de aniversario es un regalo atemporal que captura la esencia de su camino en común. En Mixtiles, ofrecemos recuerdos personalizados que te permiten reunir tus momentos favoritos en un libro elegante y bellamente encuadernado. Cada página te hace revivir recuerdos entrañables: una forma perfecta de celebrar su historia de amor.",
          "title": "¿Por qué un libro de fotos es un gran regalo de aniversario?"
        },
        "photo-books-anniversary-memories-include": {
          "content": "Incluye una mezcla de grandes hitos y momentos cotidianos para una narrativa equilibrada. Piensa en la primera foto juntos, viajes especiales y celebraciones memorables. Nuestras herramientas sencillas te permiten organizar estas fotos con fluidez para contar su historia única.",
          "title": "¿Qué recuerdos debería incluir en un libro de aniversario?"
        },
        "photo-books-anniversary-how-many-photos": {
          "content": "Puedes incluir de 24 a {{max_photos}} fotos; el número ideal depende de la historia que quieras contar. Cada libro presenta una sola disposición con una foto por página para dar protagonismo a cada recuerdo y mantener una presentación limpia y elegante.",
          "title": "¿Cuántas fotos son ideales para un libro de aniversario?"
        },
        "photo-books-anniversary-everyday-candid-moments": {
          "content": "¡Totalmente! Incluir momentos espontáneos aporta autenticidad. Esas fotos del día a día suelen captar la verdadera esencia de su relación. En Mixtiles, creemos que cada momento merece ser celebrado.",
          "title": "¿Debo incluir también momentos cotidianos o espontáneos?"
        },
        "photo-books-anniversary-personal-unique": {
          "content": "Personaliza el libro eligiendo una foto especial para la portada y un texto que resuma su historia. Nuestra plataforma te permite recortar y ordenar las fotos para que encajen con tu narrativa. Con nuestras páginas de tacto sedoso, el libro se verá increíble y se sentirá único para su relación.",
          "title": "¿Cómo hago que el libro de aniversario sea personal y único?"
        },
        "photo-books-anniversary-any-year-celebration": {
          "content": "Sí, los libros de aniversario son perfectos para cualquier año de celebración. Ya sea el primero o el cincuenta, nuestros libros realzan la belleza de tus recuerdos con tapas duras mate duraderas. Una forma significativa de conmemorar su camino juntos, año tras año.",
          "title": "¿Sirven para celebrar cualquier año?"
        },
        "photo-books-anniversary-photo-quality": {
          "content": "Para obtener impresiones nítidas, usa fotos entre 600 × 600 y 7000 × 7000 píxeles. Nuestra plataforma te avisará si alguna imagen no cumple estos estándares, para que puedas elegir alternativas y lograr un libro perfecto.",
          "title": "¿Qué calidad de foto debo usar para un álbum de aniversario?"
        },
        "photo-books-anniversary-tell-love-story": {
          "content": "Empieza organizando las fotos de forma cronológica o temática para reflejar su recorrido. Usa nuestro proceso con un toque para subir y ordenar fácilmente. Con Mixtiles, tienes libertad creativa para crear un libro que cuente su historia de amor y se convierta en un recuerdo para toda la vida.",
          "title": "¿Cómo contamos nuestra historia de amor a través del libro?"
        },
        "photo-books-mothers-day-perfect-gift": {
          "content": "Un libro de fotos es un regalo perfecto para el Día de la Madre porque captura recuerdos queridos en un formato tangible que se puede revivir una y otra vez. En Mixtiles, ofrecemos libros bellamente encuadernados que te permiten crear un recuerdo personalizado. A diferencia de un álbum tradicional, nuestros libros cuentan con tapa dura mate y páginas de papel aterciopelado con tacto sedoso, asegurando un regalo premium que mamá atesorará.",
          "title": "¿Por qué un libro de fotos es un regalo perfecto para el Día de la Madre?"
        },
        "photo-books-mothers-day-memories-include": {
          "content": "Al crear el libro para el Día de la Madre, incluye una mezcla de momentos en familia, grandes viajes y eventos importantes. Estos recuerdos muestran el camino y el vínculo que compartes con tu mamá. Nuestras herramientas de edición te permiten organizar las fotos como quieras para que cada recuerdo tenga su foco.",
          "title": "¿Qué recuerdos debería poner en un libro para el Día de la Madre?"
        },
        "photo-books-mothers-day-personalize-book": {
          "content": "Personalizar tu libro es muy sencillo con Mixtiles. Puedes añadir pies de foto y notas en cada página para dar contexto y mensajes cariñosos que aumenten el impacto emocional del regalo. Elige una foto especial para la portada y personaliza el texto para resumir tu historia; así lograrás un libro verdaderamente único.",
          "title": "¿Cómo puedo personalizar el libro para mamá?"
        },
        "photo-books-mothers-day-creative-themes": {
          "content": "Los temas creativos pueden ir desde \"Un año en imágenes\" y \"Generaciones de amor\" hasta \"Los momentos favoritos de mamá\". Cada libro tiene una sola disposición con una foto por página, lo que ayuda a contar una historia cohesionada. Nuestra plataforma organiza tus fotos automáticamente, para crear un libro impresionante en pocos toques.",
          "title": "¿Qué temas creativos funcionan para un libro del Día de la Madre?"
        },
        "photo-books-mothers-day-shared-activities": {
          "content": "¡Por supuesto! Incluir fotos de actividades compartidas y momentos especiales es esencial para un libro significativo. Estas imágenes capturan la esencia de su relación y resaltan experiencias que los acercaron. Nuestros libros están diseñados para mostrar estos recuerdos con colores vibrantes y alta calidad de impresión.",
          "title": "¿Debo incluir actividades compartidas y momentos especiales?"
        },
        "photo-books-mothers-day-how-far-back": {
          "content": "No hay una regla estricta sobre cuán atrás ir con las fotos. Incluye una mezcla de imágenes recientes y antiguas que cuenten la historia de su relación a lo largo del tiempo. Con Mixtiles, puedes subir hasta {{max_photos}} fotos, con espacio de sobra para una colección completa.",
          "title": "¿Hasta qué época debo retroceder con las fotos?"
        },
        "photo-books-mothers-day-quotes-messages": {
          "content": "Sí, añadir citas o mensajes cariñosos es una gran forma de personalizar el libro. Ya sea una frase favorita de tu mamá o una cita que resuene con su relación, estos detalles aumentan la profundidad emocional del regalo. Nuestra plataforma te permite integrar texto fácilmente junto a las imágenes.",
          "title": "¿Puedo añadir citas o mensajes emotivos?"
        },
        "photo-books-mothers-day-creation-steps": {
          "content": "Crear un libro personalizado para el Día de la Madre es muy sencillo. Sube al menos 24 fotos en nuestra web o app. Nuestro proceso único de un toque las organiza por ti, y luego puedes personalizar más si quieres. Cuando esté listo, pídelo directamente desde la plataforma. Si necesitas ayuda, nuestro equipo de soporte está disponible por correo o chat en vivo para acompañarte en cada paso.",
          "title": "¿Qué pasos hay para crear un libro del Día de la Madre?"
        },
        "photo-books-deals-current-available": {
          "content": "En Mixtiles ofrecemos con frecuencia promociones para ayudarte a ahorrar en recuerdos personalizados. La mayoría de los descuentos van del 15 % al 20 % y suelen estar disponibles en temporadas, festivos o campañas especiales. ¿Lo mejor? No necesitas buscar códigos: cuando hay una promoción activa, se aplica automáticamente a tu carrito. Empieza a crear tu libro y verás el descuento al pagar.\n\nNuestros libros no solo son preciosos, también son facilísimos de crear gracias a nuestro proceso de un toque. Sube tus momentos favoritos y nosotros los organizamos en un libro listo para pedir — sin ediciones complicadas (¡a menos que tú quieras!).",
          "title": "¿Qué ofertas de libros de fotos hay ahora en Mixtiles?"
        },
        "photo-books-deals-apply-promo-code": {
          "content": "Aunque muchas ofertas se aplican automáticamente, a veces recibirás un código por correo o redes sociales. Para aplicarlo manualmente:<ol><li>Toca el ícono de menú (☰) en la esquina superior de nuestra web o app.</li><li>Selecciona Código promocional.</li><li>Haz clic en Agregar código promocional al final de la pantalla.</li><li>Ingresa tu código y pulsa Listo.</li></ol>Así de simple. Al aplicarlo, verás el descuento en tu carrito al instante. Si no funciona, comprueba que no haya caducado y que no se esté combinando con otra oferta.",
          "title": "¿Cómo aplico un código promocional para conseguir una oferta?"
        },
        "photo-books-deals-combine-multiple": {
          "content": "Nuestro sistema admite una sola promoción por pedido. Aunque nos encanta ofrecer buenas ofertas, los descuentos no se pueden acumular. Si tienes más de un código válido, te recomendamos guardar el segundo para tu próximo libro.\n\nNos gusta mantenerlo simple —como nuestros libros—, sin tener que mezclar códigos para obtener un gran precio.",
          "title": "¿Puedo combinar varias ofertas o códigos?"
        },
        "photo-books-deals-bigger-orders": {
          "content": "Nuestro modelo de precios es diferente. En Mixtiles, los libros tienen un precio fijo, sin importar cuántas páginas incluyas. Eso significa que puedes añadir más recuerdos sin preocuparte por costos extra.\n\nA diferencia de muchos competidores, no cobramos por página. Así, el precio es simple y transparente, y casi no hace falta ofrecer descuentos por volumen. Tu libro puede tener 20 fotos o 80, y el precio será el mismo.",
          "title": "¿Por qué las ofertas no son mejores con pedidos más grandes?"
        },
        "photo-books-deals-stay-updated": {
          "content": "Para enterarte primero de nuestras ofertas, te recomendamos:<ul><li>Suscribirte a nuestros correos en <a href=\"https://www.mixtiles.com/getstarted\" target=\"_blank\" rel=\"noopener noreferrer\">www.mixtiles.com/getstarted</a></li><li>Seguirnos en Instagram y Facebook, donde compartimos promociones exclusivas</li></ul>Nuestros suscriptores suelen recibir acceso anticipado a promociones por tiempo limitado y descuentos especiales. Ya sea para imprimir un viaje reciente o crear un regalo significativo, estar conectado asegura que no te pierdas nada.",
          "title": "¿Cómo me mantengo al día con las próximas ofertas?"
        },
        "photo-books-christmas-why-make": {
          "content": "Crear un libro de fotos de Navidad te permite preservar recuerdos festivos en un formato tangible. Ofrecemos libros bellamente encuadernados que te permiten revivir cada momento especial, desde decorar el árbol hasta las cenas familiares. No son solo colecciones de imágenes: son recuerdos que capturan la alegría y la calidez de la temporada.",
          "title": "¿Por qué hacer un libro de fotos de Navidad?"
        },
        "photo-books-christmas-photos-include": {
          "content": "Un libro navideño debería incluir fotos que capturen la esencia de tus celebraciones: decorar el árbol, abrir regalos y comidas en familia. Estos momentos son parte integral del espíritu navideño y, con nuestros libros impresos en papel de tacto sedoso, cobrarán vida con colores vibrantes.",
          "title": "¿Qué fotos debo incluir en un álbum de Navidad?"
        },
        "photo-books-christmas-theme-book": {
          "content": "Dar un tema a tu libro de Navidad añade un extra de personalización. Temas populares: \"Maravilla invernal\", con paisajes nevados y escenas acogedoras, o \"Navidad en casa\", destacando momentos familiares entrañables. Con Mixtiles tienes libertad para ordenar y tematizar tus fotos como lo imagines.",
          "title": "¿Cómo doy un tema a un libro de Navidad?"
        },
        "photo-books-christmas-decorations-captions": {
          "content": "Añadir elementos navideños o pies de foto puede potenciar la narración. Nuestras herramientas te permiten personalizar cada página con textos o decoraciones que complementen tus imágenes. Ya sea un borde festivo o una cita emotiva, estas adiciones hacen el libro todavía más especial.",
          "title": "¿Debería añadir decoraciones o pies de foto?"
        },
        "photo-books-christmas-snowy-outdoor-photos": {
          "content": "¡Claro! Incluir fotos nevadas o escenas de invierno al aire libre aporta variedad y profundidad a tu libro. Nuestros libros están pensados para destacar cada recuerdo con una foto por página, mostrando incluso los detalles más pequeños.",
          "title": "¿Puedo incluir fotos nevadas o al aire libre?"
        },
        "photo-books-christmas-creative-ideas": {
          "content": "Para un toque creativo, considera usar pegatinas y citas en tu libro. Ofrecemos herramientas para personalizar y añadir toques que reflejen tu espíritu navideño. Estos elementos creativos transforman tu libro en una pieza única.",
          "title": "¿Qué ideas creativas hay para un libro navideño?"
        },
        "photo-books-christmas-meaningful-gift": {
          "content": "Un libro de Navidad es un regalo con significado: una colección personalizada de recuerdos para atesorar durante años. Con nuestras tapas duras mate, es perfecto para compartir historias y experiencias con tus seres queridos.",
          "title": "¿Cómo puede ser un libro navideño un regalo especial?"
        },
        "photo-books-christmas-creation-steps": {
          "content": "Crear un libro navideño con Mixtiles es simple e intuitivo. Empieza eligiendo un tema y tus fotos favoritas. Sube un mínimo de 24 imágenes en nuestra web o app y nuestro proceso de un toque las organizará en un libro listo para pedir. Luego puedes personalizarlo para que refleje tu historia única.",
          "title": "¿Qué pasos sigo para crear un libro de Navidad?"
        },
        "photo-books-12x12-sizes-formats": {
          "content": "Ofrecemos nuestros libros en tres tamaños, incluido el impresionante formato {{size_display}}. Es perfecto si buscas un impacto visual llamativo. Nuestros libros {{size_display}} tienen tapa dura mate elegante que asegura durabilidad y estilo.",
          "title": "¿En qué tamaños y formatos vienen los libros {{size_display}}?"
        },
        "photo-books-12x12-pages-contain": {
          "content": "Nuestros libros {{size_display}} pueden incluir entre 24 y {{max_photos}} de tus mejores recuerdos, con una foto por página para dar a cada momento el foco que merece. Ideal tanto para un evento concreto como para una colección extensa.",
          "title": "¿Cuántas páginas puede tener un libro {{size_display}}?"
        },
        "photo-books-12x12-cover-materials": {
          "content": "Fabricamos nuestros libros {{size_display}} con materiales premium: papel de tacto sedoso que realza la viveza de las fotos. La tapa dura está recubierta con una fina película mate que aporta durabilidad y un toque de sofisticación.",
          "title": "¿Qué materiales de cubierta hay para los libros {{size_display}}?"
        },
        "photo-books-12x12-lay-flat-hardcover": {
          "content": "Nuestros libros son de tapa dura para preservar tus recuerdos de forma resistente y duradera. No son de apertura plana (lay‑flat), pero la tapa dura protege y presenta tus fotos con elegancia.",
          "title": "¿Los libros {{size_display}} son lay‑flat o de tapa dura?"
        },
        "photo-books-12x12-good-for": {
          "content": "Un libro {{size_display}} es ideal para lucir en la mesa de centro, convirtiéndose en una pieza central que invita a hojear tus momentos favoritos. Su mayor tamaño es perfecto para grandes imágenes, permitiendo que los detalles brillen y cuenten tu historia con fuerza.",
          "title": "¿Para qué es especialmente bueno un libro {{size_display}}?"
        },
        "photo-books-12x12-compare-smaller": {
          "content": "Comparado con tamaños más pequeños, el {{size_display}} ofrece un lienzo más amplio para tus fotos, ideal para imágenes detalladas y relatos completos. Este formato garantiza que cada detalle se aprecie.",
          "title": "¿Cómo se comparan los libros {{size_display}} con los tamaños menores?"
        },
        "photo-books-12x12-price-range": {
          "content": "Por su tamaño y materiales premium, el libro {{size_display}} suele tener un precio superior al de opciones más pequeñas. Sin embargo, la inversión merece la pena si buscas un escaparate de alta calidad e impacto.",
          "title": "¿Qué rango de precios tienen los libros {{size_display}}?"
        },
        "photo-books-12x12-professional-portfolio": {
          "content": "¡Absolutamente! Nuestros libros {{size_display}} son ideales para álbumes profesionales o portfolios. Con impresión premium y ajustes personalizables, ofrecen una presentación pulida e impresionante de tu trabajo o proyectos especiales.",
          "title": "¿Puedo usar el formato {{size_display}} para un portfolio profesional?"
        },
        "photo-books-8x8-what-makes-special": {
          "content": "Un libro {{size_display}} es un álbum compacto y cuadrado que muestra hermosamente tus recuerdos. En Mixtiles, combinamos tapa dura mate con páginas de papel de tacto sedoso. Es perfecto para quien busca un tamaño manejable sin renunciar a la calidad.",
          "title": "¿Qué es un libro {{size_display}} y qué lo hace especial?"
        },
        "photo-books-8x8-mix-portrait-landscape": {
          "content": "Sí, puedes mezclar fotos verticales y horizontales en tu libro {{size_display}}. Nuestras herramientas te permiten hacer zoom, recortar y reorganizar para que encajen perfecto. Una foto por página para dar protagonismo a cada imagen.",
          "title": "¿Puedo mezclar fotos verticales y horizontales en un {{size_display}}?"
        },
        "photo-books-8x8-cover-options": {
          "content": "Nuestros libros {{size_display}} vienen con tapa dura mate premium que añade durabilidad y elegancia. Puedes personalizar la portada eligiendo una foto especial y editando el texto \"Happy Moments\" para hacerlo tuyo. Un toque personal que resume tu historia de un vistazo.",
          "title": "¿Qué opciones de portada hay para los libros {{size_display}}?"
        },
        "photo-books-8x8-good-occasions": {
          "content": "El formato {{size_display}} es ideal para muchas ocasiones: reuniones familiares, vacaciones, bodas o hitos de vida. Su tamaño compacto lo convierte en un recuerdo perfecto para regalar y compartir.",
          "title": "¿Para qué ocasiones es bueno un {{size_display}}?"
        },
        "photo-books-8x8-pages-have": {
          "content": "Nuestros libros {{size_display}} pueden tener entre 24 y {{max_photos}} páginas, para mostrar una amplia gama de recuerdos. Esta flexibilidad asegura que, tengas pocas o muchas fotos, puedas contar tu historia como quieras.",
          "title": "¿Cuántas páginas puede tener un {{size_display}}?"
        },
        "photo-books-8x8-square-format-display": {
          "content": "Sí, el {{size_display}} es un formato cuadrado, fácil de exhibir en mesas, estantes o escritorios. Su tamaño compacto y diseño elegante lo hacen muy versátil.",
          "title": "¿Los libros {{size_display}} son cuadrados y fáciles de exhibir?"
        },
        "photo-books-8x8-templates-styles": {
          "content": "En Mixtiles ofrecemos un flujo simplificado de un toque que organiza automáticamente tus fotos en una disposición coherente. Aunque no tenemos múltiples plantillas, nuestra plataforma intuitiva permite personalizar el orden y el recorte para lograr el estilo que te guste.",
          "title": "¿Qué plantillas o estilos hay para los {{size_display}}?"
        },
        "photo-books-8x8-why-choose": {
          "content": "Elegir un {{size_display}} ofrece el equilibrio perfecto entre portabilidad y presencia. Es lo suficientemente grande para lucir las fotos y lo bastante compacto para manipular y guardar con facilidad. Es un tamaño muy versátil que encaja en cualquier entorno.",
          "title": "¿Por qué elegir un {{size_display}} en lugar de otro tamaño?"
        },
        "photo-books-recipe-what-is": {
          "content": "Un libro de recetas con fotos es una manera única y personalizada de recopilar tus recetas favoritas junto a fotos atractivas. Como un recetario tradicional, te permite mostrar tanto la receta como el atractivo visual de los platos. En Mixtiles, ofrecemos libros elegantes y bellamente encuadernados que transforman tu colección culinaria en un recuerdo. Con nuestras herramientas, puedes crear un libro que cuente tu viaje culinario y sea un deleite visual para quien lo hojee.",
          "title": "¿Qué es un libro de recetas con fotos y cómo se usa?"
        },
        "photo-books-recipe-old-family-recipes": {
          "content": "Incorporar antiguas recetas familiares es una forma preciosa de preservar tradiciones culinarias. Escanea las recetas manuscritas y súbelas como imágenes. Nuestra plataforma permite integrarlas junto a fotos de los platos terminados o de la familia cocinando, creando un vínculo emotivo entre pasado y presente.",
          "title": "¿Cómo incluyo recetas familiares antiguas?"
        },
        "photo-books-recipe-themes": {
          "content": "Las posibilidades de temas son infinitas. Puedes centrarte en recetas festivas que capturen el espíritu de las reuniones, crear un libro dedicado a postres con fotos apetitosas, o explorar comidas económicas que cuiden el bolsillo sin sacrificar sabor. El tema que elijas, nuestros libros son el lienzo perfecto para tu visión culinaria.",
          "title": "¿Qué temas puedo usar para un libro de recetas?"
        },
        "photo-books-recipe-organize": {
          "content": "Organiza tus recetas como prefieras: cronológicamente para reflejar tu evolución, o por tipo (entrantes, platos principales, postres). En Mixtiles, puedes reorganizar páginas y fotos fácilmente para que tu libro sea tan práctico como bonito.",
          "title": "¿Cómo debería organizar las recetas en el libro?"
        },
        "photo-books-recipe-layout-details": {
          "content": "Cada receta debería incluir un título claro, lista de ingredientes, pasos detallados y fotos. Nuestros libros ofrecen una disposición de una foto por página para resaltar la belleza de cada plato. También puedes añadir notas personales o consejos para hacerlo más atractivo e informativo.",
          "title": "¿Qué detalles de diseño necesita cada receta?"
        },
        "photo-books-recipe-cooking-process-photos": {
          "content": "¡Claro que sí! Incluir fotos del proceso de cocina o del plato terminado añade profundidad y contexto. Nuestros libros de calidad premium, impresos en papel de tacto sedoso, hacen que cada imagen cobre vida con color y detalle, mejorando la experiencia del lector.",
          "title": "¿Puedo añadir fotos del proceso de cocina o del resultado final?"
        },
        "photo-books-recipe-family-heirloom": {
          "content": "Sí, un libro de recetas con fotos es un excelente legado familiar. Conserva la historia culinaria de tu familia y puede pasar de generación en generación. Al capturar recetas y las historias detrás de ellas, creas un recuerdo atemporal. Nuestras tapas duras mate aseguran que dure muchos años.",
          "title": "¿Es un buen legado familiar?"
        },
        "photo-books-recipe-make-engaging": {
          "content": "Para que tu libro sea realmente atractivo, añade notas personales, anécdotas o trucos junto a cada receta. Estos elementos aportan contexto y lo vuelven más interactivo. Te animamos a personalizar tu libro para reflejar tu propio viaje culinario y ofrecer una experiencia memorable a quien lo lea.",
          "title": "¿Cómo hago que el libro sea atractivo?"
        }
      },
      "fullscreen_title": "Impresiones con Calidad de Museo desde Tu Teléfono",
      "fullscreen_title_desktop": "Impresiones con Calidad de Museo",
      "made_in_canada": "Hecho en Canadá",
      "main_button_cta": "Comprar Ahora",
      "photo_wall": {
        "subtitle": "Elige el estilo perfecto para tu hogar",
        "title": "Crea una Pared de Fotos con Unos Cuantos Toques"
      },
      "secondary_title_1": "Dile Adiós a los Martillos & Clavos",
      "secondary_title_1_desktop": "Solo quita el papel protector y pega",
      "secondary_title_2": "Se Ajusta a la Perfección",
      "secondary_title_3": "No Deja Marcas",
      "meet_magnetic_hanging": "Descubre cuadros magnéticos",
      "seen-on": "Como Lo Viste En",
      "seen-on-desktop": "Como lo viste en",
      "simple_price": {
        "subtitle": "Nuestros precios son honestos, sin cargos ocultos y el envío siempre es gratis.",
        "title": "Mismo precio, sin importar cuantas páginas."
      },
      "simple_price_tiers": {
        "from_label": "Desde",
        "subtitle": "Nuestros libros tienen precios simples según tamaño y número de páginas, con envío gratis.",
        "title": "Precios Simples, Sin Sorpresas"
      },
      "title": "Las Paredes de Fotos, Reinventadas",
      "try_now": {
        "continue": "Continuar tu álbum",
        "subtitle": "Diseña tu álbum con solo unos toques y mira cómo cobra vida en 3D",
        "title": "Albumes de fotos fáciles de crear",
        "design_subtitle": "Convierte tus viajes en libros de mesa increíbles con solo unos toques",
        "design_title": "Libros de Viaje Fáciles",
        "life_events_subtitle": "Convierte los grandes momentos de tu vida en libros de mesa con unos toques.",
        "life_events_title": "Un libro precioso para cada gran momento",
        "create_now": "Crear ahora"
      },
      "email_signup": {
        "title": "Sé el primero en saber — ofertas, noticias e ideas de decoración.",
        "email_label": "Dirección de correo electrónico",
        "terms_text": "Al registrarte, aceptas los Términos de uso y la Política de privacidad de Mixtiles",
        "success_message": "Gracias por tu suscripción"
      }
    },
    "login": {
      "last_used": "Último usado",
      "continue_with": "Continuar con",
      "create_account_error": "Error al crear tu cuenta",
      "error_dialog": {
        "incorrect_email_or_code_message": "El email o el código que ingresaste es incorrecto. Intenta volver a ingresar el código o tu email.",
        "incorrect_email_or_code_title": "Email o código incorrecto",
        "login_unsuccessful_message": "Inténtalo de nuevo o contacta con soporte",
        "login_unsuccessful_title": "Error de inicio",
        "too_many_incorrect_attempts_message": "Revisa tu email para desbloquear tu cuenta.",
        "too_many_incorrect_attempts_title": "Demasiados intentos fallidos"
      },
      "email_capture_placeholder": "Ingresar email",
      "email_code": {
        "code_sent": "Código enviado al email",
        "code_sent_detailed": "Un mensaje con el código fue enviado a {{email}}",
        "resend_code": "Reenviar Código",
        "resend_code_countdown": "Podrás reenviar en {{seconds}} s",
        "enter_code": "Ingresar Código"
      },
      "login": "Iniciar sesión",
      "login_message": "{{v1}} para guardar tu progreso y seguir tus pedidos",
      "login_or_sign_up": "Iniciar sesión o Registrarse",
      "login_successfully": "¡Éxito! Te has conectado",
      "no_email_error": "Debes proporcionar acceso tu email para crear una cuenta.",
      "register_successfully": "¡Bienvenido! Registro completado",
      "restored_photo": "Se restauró tu foto guardada",
      "restored_photos": "Se restauraron tus fotos guardadas",
      "restricted": {
        "title": "Inicia sesión para ver tus pedidos"
      },
      "sign_out": "Cerrar Sesión",
      "sign_up": "Registrarme",
      "start_your_design_journey": "Inicia tu Viaje de Diseño",
      "terms_of_use": {
        "and": "y",
        "privacy_policy": "Política de Privacidad",
        "terms_of_use": "Condiciones de Uso",
        "terms_of_use_intro": "Al registrarte, aceptas nuestras"
      },
      "verify_email_dialog": {
        "button": "Más tarde",
        "content": "Hemos enviado un email a {{v1}} para asegurarnos de que eres tu y enseñarte todos tus pedidos anteriores.",
        "title": "Comprueba tu Bandeja de Entrada"
      }
    },
    "logout": {
      "signed_out_successfully": "Sesión cerrada correctamente",
      "signed_out_successfully_subtitle": "Vuelve a iniciar sesión para ver tus fotos guardadas"
    },
    "multi_product_homepage": {
      "photo_walls_title": "Paredes de Fotos",
      "photo_walls_subtitle": "Convierte tus fotos en hermoso arte para pared",
      "photo_books_subtitle": "Diseña tu libro con unos toques",
      "pet_portraits_subtitle": "Retratos divertidos y artísticos",
      "shop_now": "Comprar ahora",
      "continue_designing": "Continuar Diseñando",
      "explore_now": "Explorar",
      "download": "Descargar",
      "app_title": "La Nueva App de Mixtiles",
      "app_subtitle": "Convertimos tus mejores momentos en productos fotográficos al instante.",
      "app_store_badge": "Descargar en el App Store",
      "get_app_title": "Descarga la Nueva App de Mixtiles",
      "new_products_title": "Prueba Nuestros Nuevos Productos",
      "desktop_new_products_title": "Productos",
      "new_products": {
        "caricature": "Caricatura",
        "the_studio": "El Estudio"
      },
      "best_place_title": "El Mejor Lugar para Imprimir tus Fotos",
      "stats": {
        "rating_caption": "156,000+ reseñas",
        "customers_caption": "Clientes felices"
      },
      "desktop_stats": {
        "photos_printed_caption": "Fotos impresas"
      }
    },
    "my_orders": {
      "active_orders": "Pedidos Activos",
      "completed_orders": "Pedidos Completados",
      "no_orders_button": "Escoge Algunas Fotos",
      "no_orders_title": "Parece que todavía no has hecho ningún pedido.",
      "resend_email": "Reenviar email",
      "verify_email": "Verifica tu email"
    },
    "new_email_capture": {
      "a_box_of_mixtiles": {
        "subtitle": "Yo subiré las fotos",
        "title": "Una caja de Mixtiles",
        "tiles_or_book": "Tiles o un Fotolibro"
      },
      "agree_to_emails": "Acepto recibir información comercial y comunicaciones promocionales",
      "agree_to_emails_sign_now": "Regístrate ahora para recibir ofertas exclusivas, inspirarte y descubrir nuestros nuevos productos",
      "attribution": {
        "channels": {
          "email": "Email",
          "facebook": "Facebook",
          "flyer": "Volante",
          "friend": "Amig@",
          "game": "Juego móvil",
          "google": "Google",
          "instagram": "Instagram",
          "other": "Otro",
          "pinterest": "Pinterest",
          "snapchat": "Snapchat",
          "stacey_solomon": "Stacey Solomon",
          "rebecca_judd": "Rebecca Judd",
          "tammin_sursok": "Tammin Sursok",
          "tia_mowry": "Tia Mowry",
          "tv": "TV",
          "youtube": "Youtube",
          "airport": "Aeropuerto",
          "podcast": "Podcast",
          "shorts": "Shorts",
          "tiktok": "TikTok",
          "twitter": "Twitter"
        },
        "help_us_improve": "¡Ayúdanos a mejorar!",
        "sub_options": {
          "influencer": "Un influencer",
          "not_sure": "No estoy seguro/a",
          "paid_ad": "Un anuncio pagado"
        },
        "title": "¿Cómo nos has conocido?"
      },
      "continue": "Continuar",
      "disagree_to_emails": {
        "emphasized": "No quiero",
        "text": "Selecciona esta casilla si {{emphasized}} quieres recibir comunicaciones de marketing de nuestra parte"
      },
      "email_placeholder": "¿Cuál es tu email?",
      "for_gift": "Para otra persona",
      "for_gift_subtitle": "Quiero hacer un regalo",
      "for_me": "Para mí",
      "for_me_subtitle": "Estoy decorando mi hogar",
      "gift_card": {
        "subtitle": "Los dejaré elegir sus propias fotos",
        "title": "Tarjeta de regalo"
      },
      "gift_question": "¿Qué tipo de regalo?",
      "intro": {
        "title": "Conozcamos Mixtiles"
      },
      "lets_create": "¡Vamos a crear un regalazo!",
      "name_placeholder": "¿Cómo te llamas?",
      "privacy_disclaimer": "Al continuar, indica que ha leído y que acepta nuestras {{v1}} y {{v2}}",
      "sms_privacy_disclaimer_consent": "Al introducir tu número, aceptas recibir ofertas por SMS y aplicaciones de mensajería, según nuestra Política de Privacidad. Puedes darte de baja en cualquier momento respondiendo STOP o mediante el enlace de exclusión.",
      "sms_step_label": "¿Cuál es tu número?",
      "sms_step_title": "Recibe ofertas y promociones exclusivas en tu teléfono",
      "title": "¡Hola, {{v1}}!",
      "title_no_name": "¡Hola!",
      "who_for": "¿Para quién es?",
      "sms_privacy_disclaimer": "Al ingresar tu número de teléfono, aceptas recibir mensajes de marketing al número proporcionado. El consentimiento no es una condición de compra. Pueden aplicarse tarifas de mensajes y datos. La frecuencia de mensajes varía. Responde HELP para ayuda o STOP para cancelar. Consulta nuestros {{v1}} y {{v2}} "
    },
    "order": {
      "canada_tariff_notice_bag": "Lienzos y fotolibros no pagan aranceles",
      "canada_tariff_notice_tiles": "Los lienzos no pagan aranceles",
      "add_photos": "Añadir Fotos",
      "add_photos_count": "Añade {{v1}} fotos.",
      "add_photos_single": "Añade 1 foto.",
      "add_to_bag": "Añadir a la bolsa",
      "art": "Arte",
      "art_orientation_warning": {
        "checkout": {
          "label": {
            "singular": "El arte luce mejor en vertical."
          }
        }
      },
      "checkout": {
        "add_address": "Añadir dirección",
        "add_gift_note": "Añade un mensaje a tu pedido",
        "add_gift_note_options": {
          "close": "Cerrar",
          "description": "Añadiremos este mensaje a tu pedido (y no incluiremos el recibo)",
          "edit_note": "Editar o Eliminar Mensaje",
          "edit_options": {
            "dismiss": "Descartar",
            "edit": "Editar Texto",
            "remove": "Eliminar Mensaje"
          },
          "header": "Añade un mensaje a tu pedido",
          "placeholder": [
            "Hola, ",
            "",
            "Espero que estos momentos",
            "te gusten tanto como a mí.",
            "",
            "Un abrazo, ",
            "XX"
          ],
          "start_writing": "Empezar a Escribir"
        },
        "add_payment": "Añadir método de pago",
        "add_payment_options": {
          "credit_card_ends_with": "Acabada en {{v1}}",
          "paying_with": "Pagar con {{v1}}"
        },
        "are_you_sure": "¿Estás seguro?",
        "change_info": "Cambiar",
        "confirm_button_text_gdpr": "Confirmar & Pagar",
        "confirm_button_text_non_gdpr": "Hacer Pedido",
        "gift_note_added": "Mensaje Añadido",
        "minimum_order_fee": {
          "description": "El tamaño mínimo es {{v1}}, tenemos que cobrar la diferencia",
          "title": "Tarifa mínima de pedido"
        },
        "no_go_back": "No, volver",
        "payment_errors": {
          "add_new_card": "Añadir otra tarjeta",
          "authentication_failed_text": "Vaya, no hemos podido autenticar tu tarjeta. Porfa, añade otra y prueba de nuevo.",
          "authentication_failed_title": "Autenticación Fallida",
          "card_declined_text": "Vaya, parece que la tarjeta ha sido rechazada. Porfa, añade otra y prueba de nuevo.",
          "card_declined_text_1": "Tu tarjeta fue rechazada. Revisa los datos de tu tarjeta.",
          "card_declined_text_2": "Si todo está bien, contacta a tu banco e inténtalo de nuevo.",
          "card_declined_title_2": "Tarjeta Rechazada",
          "charge_failed_text": "Lo siento pero no hemos podido hacerte el cargo en la tarjeta. Porfa, añade otra y prueba de nuevo.",
          "charge_failed_title": "Cobro Fallido",
          "incomplete_photo_wall": {
            "missing_photos_plural": "A tu pared de fotos le faltan {{v1}} fotos",
            "missing_photos_singular": "A tu pared de fotos le falta 1 foto"
          },
          "invalid_email_text": "Vuelve a introducir tu correo electrónico para completar tu pedido.",
          "invalid_email_title": "Introduce tu correo electrónico",
          "no_charge_text": "No te preocupes, no te hemos cobrado",
          "no_tiles_selected": "¡No hay cuadros seleccionados!",
          "oops_order_failed": "Ups, Pedido Fallido",
          "order_error_text": "Lo sentimos, no pudimos completar tu pedido. Puedes probar de nuevo o mandarnos un mensaje.",
          "order_error_title": "Pedido fallido",
          "payment_error_text": "Lo sentimos, no hemos podido completar tu pedido por un error en el pago. Puedes probar de nuevo o mandarnos un mensaje. ",
          "payment_error_title": "Pago fallido",
          "uploads_failed_text": "Tuvimos problemas al procesar algunas de tus fotos. Intenta subirlas de nuevo.",
          "order_price_calculation": {
            "subtitle": "Por favor, actualiza la página. No te preocupes, tus fotos se guardarán.",
            "title": [
              "Lo sentimos, hubo un problema",
              "al calcular el precio"
            ]
          }
        },
        "payment_methods": "Métodos de Pago",
        "payment_summary_rows": {
          "add_many_more_to_get_discount": "Añade {{v1}} cuadros más y tendrás un descuento del {{v2}}%",
          "add_more_to": {
            "get_more_many": "¡Añade {{v1}} cuadros y tendrás {{v2}} gratis!",
            "get_more_one": "¡Añade {{v1}} cuadros y tendrás uno gratis!"
          },
          "add_one_more_to_get_discount": "Añade un cuadro más y tendrás un descuento del {{v1}}%",
          "add_one_to": {
            "get_more_many": "¡Añade un cuadro y tendrás {{v2}} más gratis!",
            "get_more_one": "¡Añade un cuadro y tendrás otro gratis!"
          },
          "are_free": "{{v1}} son gratis",
          "base_price_many": "{{v1}} cuadros, {{v2}} cada uno",
          "bundle_action": {
            "add_another_many": "¡añade {{v1}} cuadros más para otro descuento!",
            "add_another_one": "¡añade un cuadro más para otro descuento!",
            "add_many": "¡añade {{v1}} cuadros más para tener la oferta!",
            "add_many_short": "añade {{v1}} más para la oferta",
            "add_one": "¡añade un cuadro más para tener la oferta!",
            "add_one_short": "añade 1 más para la oferta",
            "get_next_bundle": "consigue {{v1}} por {{v2}}",
            "perfect": "¡Genial! Te has ahorrado {{v1}}."
          },
          "bundle_change_to_size": "Cambia la medida a {{v1}} para poder usar el código",
          "buy_over_percent_off_orders": "{{v1}}% de descuento en pedidos",
          "buy_over_percent_off_orders_over_price": "{{v1}}% de descuento en pedidos superiores a {{v2}}",
          "buy_over_price_applied": "¡Hurrah! Te has ahorrado {{v1}}%",
          "buy_over_price_applied_saved": "¡Hurrah! Te has ahorrado {{v1}}",
          "discount_percentage_literal": "Te has ahorrado {{v1}}%",
          "buy_over_price_buy_more": "Añade {{v1}} más para tener la oferta",
          "buy_over_price_buy_more_short": "añade {{v1}} para el descuento",
          "buy_over_tier": "{{v1}}% si compras {{v2}}+",
          "buy_over_tiers_pair": "{{v1}} • {{v2}}",
          "buy_x_get_y": "{{v1}}+{{v2}}",
          "buy_x_get_y_action": {
            "get_more_many": "Puedes añadir {{v1}} cuadros gratis.",
            "get_more_one": "Puedes añadir otro cuadro gratis.",
            "saved": "¡Yuju, te has ahorrado {{v1}}!",
            "yay_get_many": "¡Yuju, tus siguientes {{v1}} cuadros son gratis!",
            "yay_get_one": "¡Yuju, tu siguiente cuadro es gratis!"
          },
          "can_add_free_tiles": "¡Puedes añadir {{v1}} cuadros gratis!",
          "can_add_one_free_tile": "¡Puedes añadir un cuadro gratis!",
          "canvas_tile": "1 cuadro de lienzo",
          "canvas_tiles": "{{v1}} cuadros de lienzo",
          "color_tiles": "{{v1}} cuadros {{color}}",
          "delivery_by": "Entrega para",
          "discount": "Descuento",
          "discount_off_over_price": "{{v1}}% menos en compras superiores a {{v2}}",
          "discount_off_over_price_short": "-{{v1}}% desde {{v2}}",
          "discount_percentage": "{{v1}}% de descuento",
          "discounts_applied": "{{v1}} aplicado",
          "eligible_free_shipping": "Elegible para envío gratis",
          "eligible_free_shipping_over": "Disfruta de envío gratis en órdenes de más de {{v1}}",
          "free": "GRATIS",
          "free_shipping": "Envío gratis",
          "free_shipping_over": "Envío gratis desde {{v1}}",
          "free_tiles_many": " {{v1}} cuadros gratis",
          "free_tiles_single": "1 cuadro gratis",
          "is_free": "1 es gratis",
          "all_free": "gratis",
          "many_tiles": " {{v1}} cuadros",
          "mixed_frames": "marcos mixtos",
          "mixed_sizes_and_frames": "tamaños y marcos mixtos",
          "more_tiles_many": " {{v1}} cuadros más",
          "more_tiles_one": "1 cuadro más",
          "more_tiles_with_each_price": "{{v1}} adicionales, {{v2}} cada uno",
          "one_color_tile": "1 cuadro {{color}}",
          "one_tile": "1 cuadro",
          "photo_book_description_plural": "Álbumes de Fotos ({{v1}} páginas)",
          "photo_book_description_singular": "Álbum de Fotos ({{v1}} páginas)",
          "sales_tax": "Impuestos",
          "select_more_tiles_many": "Selecciona {{v1}} cuadros más",
          "select_more_tiles_one": "Selecciona un cuadro más",
          "select_some_tiles": "Agrega algunas fotos",
          "shipping": "Envío",
          "subtotal": "Total",
          "tax": "Impuestos",
          "tiles_count": "{{v1}} cuadros",
          "tiles_size_many": "{{v1}} cuadros por {{v2}}",
          "total": "Total",
          "wall_sign": "letrero de pared",
          "wall_signs": "letreros de pared",
          "wide_frame_tile": "1 cuadro de marco ancho {{color}}",
          "wide_frame_tiles": "{{v1}} cuadros de marco ancho {{color}}",
          "will_be_free_many": "¡{{v1}} cuadros serán gratis!",
          "will_be_free_one": "¡Uno será gratis!",
          "creditUsed": "Crédito",
          "discount_percentage_automatic": "{{v1}}% de descuento en fotolibros",
          "import_fee": "Tarifa de Importación",
          "international_taxes": "Impuestos Locales",
          "many_books": "{{v1}} libros,{{v2}}"
        },
        "promo": {
          "cancel": "Cancelar Código de Descuento",
          "free_tiles": "Cuadros Gratis",
          "free_books": "Libros de fotos gratis",
          "title": "Promoción",
          "yes_remove": "Sí, eliminar código"
        },
        "shipping_options": {
          "calculating_delivery_date": "Calculando fecha de entrega...",
          "delivery_by": "Entrega para el {{v1}}",
          "express_new_version": "Envío Express - {{v1}}",
          "express_name": "Envío Express",
          "priority": "Envío Prioritario - {{v1}}",
          "priority_name": "Envío Prioritario",
          "standard": "Envío Estándar",
          "estimated_delivery": "Est. {{v1}}"
        },
        "tokushoho_disclaimer": "返品・キャンセル条件／特定商取引法に基づく表記",
        "gift_card_available_credits": "{{v1}} disponible",
        "gift_card_credits": "Créditos de Tarjeta Regalo",
        "gift_card_remove_title": "¿Estás seguro de que quieres eliminar tu tarjeta regalo?"
      },
      "add_product": "Añadir producto",
      "cart_title": "Mi bolsa",
      "cart_volume_discount": "DESCUENTO POR VOLUMEN",
      "cart_add_promo": "Añadir promo",
      "cart_change_promo": "Cambiar promo",
      "cart_free_shipping_applied": "Envío gratis aplicado",
      "cart_bag": "Bolsa",
      "empty_bag_title": "Tu bolsa está vacía",
      "empty_bag_cta": "Comprar ahora",
      "cart_edit": "Editar",
      "cart_header": {
        "photo_book": "Libro de Fotos",
        "tiles_one": "1 Cuadro",
        "tiles_other": "{{count}} Cuadros"
      },
      "cart_summary": {
        "tiles_one": "{{count}} cuadro",
        "tiles_other": "{{count}} cuadros",
        "wall_signs_one": "{{count}} letrero de pared",
        "wall_signs_other": "{{count}} letreros de pared",
        "with_size": "{{item}}, {{size}}",
        "frame_breakdown_row_one": "{{count}} {{frame}} cuadro, {{size}}",
        "frame_breakdown_row_many": "{{count}} {{frame}} cuadros, {{size}}",
        "canvas_breakdown_row": "{{count}} {{frame}}, {{size}}",
        "frame_tiles_one": "{{count}} {{frame}} cuadro",
        "frame_tiles_many": "{{count}} {{frame}} cuadros",
        "canvas_tiles": "{{count}} {{frame}}",
        "combined_no_size": "{{tiles}} y {{signs}}",
        "mixed_sizes_lower": "tamaños mixtos",
        "mixed_frames": "marcos mixtos",
        "photo_book": "Libro de fotos, {{size}}",
        "book_with_pages": "Libro, {{size}}, {{pageCount}} páginas"
      },
      "checkout_button_text": "Confirmar",
      "choose_from_phone": "Seleccionar del teléfono",
      "done": {
        "confirmation_email": "Deberías recibir un email de confirmación en unos minutos",
        "delivery_time": "Recibirás tu pedido para el {{v1}}",
        "next": "Siguiente",
        "please_hold": "¡Genial! Porfa, espera mientras completamos tu pedido. ",
        "will_receive_email": "Recibirás un email de confirmación en breve en ",
        "woohoo": "¡Yujuuu! ¡Todo listo!"
      },
      "faces_cropped_warning": {
        "cart_cta": "Revisar y corregir",
        "cart_label": "Rostro recortado.",
        "cta": {
          "change_size": "Cambiar Tamaño",
          "crop": "Arreglar Ajuste"
        },
        "label": "Hay algunas caras recortadas.",
        "notification": {
          "change_size": {
            "cta": "Deshacer",
            "title": "El cuadro ha cambiado a {{size}}"
          },
          "crop": {
            "cta": "Deshacer",
            "title": "El ajuste del cuadro ha cambiado"
          }
        }
      },
      "filters": {
        "dramatic": "Dramático",
        "noir": "Noir",
        "none": "Ninguno",
        "painting": "Pintura",
        "painting2": "Pintura 2",
        "pencil": "Lápiz",
        "pencil2": "Lápiz 2",
        "silver": "Plata",
        "sketch": "Dibujo",
        "sketch2": "Dibujo 2",
        "vivid": "Vívido",
        "winter": "Invierno",
        "b_n_w": "B&N",
        "b_n_w2": "B&N2",
        "original": "Original",
        "vivid2": "Vivid 2"
      },
      "frame_colors": {
        "black": "Negro",
        "none": "Sin marco",
        "red_ash_wood": "Nuez",
        "white": "Blanco",
        "wood": "Madera de Roble"
      },
      "frame_presets": {
        "earthy_blend": "Mezcla Natural",
        "classic_blend": "Mezcla Clásica",
        "harmony_mix": "Mezcla Armonía"
      },
      "import_from_google_photos": "Importar desde Google Fotos",
      "low_quality_warning": {
        "action_keep": "Usar de todas formas",
        "action_remove": "Eliminar del pedido",
        "banner": {
          "cta": "Aprobar fotos",
          "text": "Estas fotos están por debajo de la resolución recomendada, podrían verse borrosas al imprimirlas",
          "title": "Revisar Fotos con Baja Resolución"
        },
        "text": "Esta foto es bastante pequeña. ¡Probablemente saldrá borrosa en un cuadro!",
        "title": "Calidad de Imagen Baja",
        "warning": {
          "cta": "Reemplazar",
          "cta_try_in_size": "Pruébalo en {{sizeName}}",
          "label": "Foto con baja resolución."
        }
      },
      "materials": {
        "canvas": "Lienzo",
        "classic": "Marco clásico",
        "frameless": "Sin marco",
        "wide_frame": "Marco Ancho",
        "sticker": "Sticker"
      },
      "materials_detailed_descriptions": {
        "canvas": "Lona de primera calidad para una apariencia elevada. Impreso en algodón estirado, con fácil montaje magnético.",
        "classic": "Una apariencia clásica y de primera calidad. Impreso en papel superior con fácil montaje magnético.",
        "frameless": "Un diseño moderno y minimalista. Impreso en papel superior, con fácil montaje magnético.",
        "wide_frame": "Elegancia audaz para una apariencia de primera calidad. Impreso en papel superior con fácil montaje magnético."
      },
      "materials_plural": {
        "classic": "Marcos clásicos",
        "wide_frame": "Marcos anchos"
      },
      "mats": {
        "deep": "Profundo",
        "medium": "Medio",
        "none": "Ninguno",
        "shallow": "Delgado",
        "heart": "Corazón",
        "round": "Redondo"
      },
      "promo_code_errors": {
        "messages": {
          "already_a_user": "Parece que este código es solo para primeros pedidos. ¡Lo siento!",
          "already_registered": "Este código ya ha sido registrado",
          "default": "Parece que ése código no existe. ¡Lo siento!",
          "expired": "Parece que este código de descuento ha caducado. ¡Lo siento!",
          "non_existing": "Parece que ese código no existe. ¡Lo siento!",
          "quantity_exceeded": "¡Este código ya fue ingresado! No necesitas ingresarlo de nuevo. Solo usa el dispositivo en el que ingresaste el código originalmente, avanza a la pantalla de Pago, y tus cuadros estarán listos.",
          "redemptions_per_customer_exceeded": "¡Ups! Parece que este código de descuento ya ha sido usado. ¡Lo siento!",
          "self_referral": "Este código es para todos los amig@s a los que recomiendes Mixtiles.",
          "server_error": "¡Uy! Parece que tuvimos un problemita al verificar tu código. Porfa, prueba de nuevo o escríbenos. "
        },
        "titles": {
          "gift_card_empty": "Esta tarjeta regalo ha sido canjeada en su totalidad",
          "gift_card_inactive": "Esta tarjeta regalo no está activa"
        }
      },
      "styles": {
        "mixed_styles": "Mixto"
      },
      "tile_actions": {
        "adjust": "Ajustar Recorte",
        "remove": "Eliminar",
        "remove_photo": "Eliminar Foto",
        "replace": "Reemplazar Foto",
        "replace2": "Reemplazar",
        "replace_subtitle": "Elige una foto existente o sube una nueva"
      },
      "upload_failed": {
        "action_continue": "Continuar",
        "format_not_supported": "Algunos archivos no son compatibles. Por favor conviértelos a JPG o PNG.",
        "text": "Tuvimos problemas para subir tu foto. Vuelve a intentarlo o elige otra foto.",
        "title": "Fallo al subir"
      },
      "upload_photo": "Subir foto",
      "upload_photos": "Subir fotos",
      "what_to_add": "¿Qué deseas agregar?",
      "incomplete_collage_warning": {
        "label": "Faltan fotos en el collage."
      },
      "ai_tile_generating_warning": {
        "label": "Tu nuevo estilo aún se está creando.",
        "cta": "Ver",
        "popup_subtitle": "Podrás pagar en cuanto esté listo."
      },
      "list_discount": {
        "banner": "Presidents' Day: {{v1}}% de Descuento en Fotolibros"
      },
      "remove_item_popup": {
        "title": "¿Seguro que quieres eliminarlo?",
        "tiles": "Esto eliminará los cuadros que creaste",
        "photo_book": "Esto eliminará el libro de fotos que creaste",
        "delete": "Eliminar"
      }
    },
    "cart_upsells": {
      "bath_time": {
        "card_title_dog": "¡Convierte a tu perro en divertido arte de baño!",
        "card_title_cat": "¡Convierte a tu gato en divertido arte de baño!",
        "card_cta": "Ver ahora",
        "flow_title": "Hora del baño"
      },
      "card_dismiss": "Descartar",
      "wall_subtitle_one": "{{count}} cuadro, {{size}}",
      "wall_subtitle_other": "{{count}} cuadros, {{size}}",
      "add_tiles_one": "Añadir {{count}} cuadro",
      "add_tiles_other": "Añadir {{count}} cuadros",
      "select_tiles_to_add": "Elige cuadros para añadir",
      "select_tiles_to_continue": "Elige cuadros para continuar",
      "wall_tile": "Cuadro {{position}}"
    },
    "order_management": {
      "actions": {
        "change_address": "Cambiar Dirección",
        "edit_order": "Editar Pedido",
        "duplicate_order": "Duplicar Pedido",
        "tracking_details": {
          "base": "Detalles de Seguimiento",
          "not_shipped_suffix": "una vez enviado"
        },
        "edit_order_dialog": {
          "title": "¿Cancelar y editar?",
          "subtitle": "Cancelar y editar detendrá tu pedido para que puedas actualizarlo.",
          "refund_info": "Recibirás un crédito de {{v1}} para usar al pagar. Para obtener un reembolso en su lugar, contacta con soporte después de cancelar.",
          "button": "Cancelar y editar pedido",
          "go_back": "Mantener mi pedido"
        },
        "view_order_summary": "Ver Resumen del Pedido"
      },
      "already_shipped_dialog": {
        "cancel_text": "Este pedido ya ha entrado en producción, por lo que ya no se puede cancelar.",
        "cancel_title": "Demasiado tarde para cancelar",
        "update_text": "Este pedido ya ha entrado en producción, por lo que ya no se puede modificar.",
        "update_title": "Demasiado tarde para modificar",
        "ok": "Entendido"
      },
      "got_it": "Entendido",
      "modifying_existing_order_dialog": {
        "ok": "Entendido",
        "text": "Los cambios que hagas pueden alterar la fecha de entrega",
        "title": "Modificar un pedido existente"
      },
      "order_card": {
        "created_at": "Creado el",
        "delivered_at": "Entregado el",
        "expected_arrival": "Llegada Estimada",
        "number_of_photo_books": "Número de Álbumes de Fotos",
        "number_of_tiles": "Número de Cuadros",
        "order_number_prefix": "Pedido"
      },
      "order_processing": {
        "cant_view_file": "No se puede descargar. Prueba con otro navegador"
      },
      "order_processing_dialog": {
        "text": "Estamos procesando tu pedido. Prueba de nuevo en unos minutos.",
        "title": "Procesando Pedido"
      },
      "statuses2": {
        "approved": "En Producción",
        "cancelled": "Cancelado",
        "complete": "Entregado",
        "processing": "Procesando",
        "shipped": "En Camino"
      },
      "title": "Tu Pedido"
    },
    "out_of_stock": {
      "applied_to_other_materials": "Aplicado a otros materiales",
      "applied_to_x": "Aplicado a  {{v1}}",
      "applied_where_available": "Aplicado donde esté disponible",
      "available_in_other_materials": "Disponibles en otros materiales",
      "available_in_other_sizes": "Disponible en otros tamaños",
      "only_available_for_x": "Solo disponible para {{v1}}",
      "some_tiles_arent_available_for_this_option": "Algunos cuadros no están disponibles para esta opción ",
      "undo": "Deshacer",
      "we_changed_some_frame_that_werent_available": "Cambiamos algunos cuadros que no estaban disponibles",
      "x_isnt_available_in_x": "{{v1}} no está disponible en {{v2}}",
      "x_isnt_available_size_changed_to_x_subtitle": [
        "El tamaño cambió a {{v1}}"
      ],
      "x_isnt_available_size_changed_to_x_title": [
        "{{v1}} no está disponible"
      ],
      "x_only_available_in_x": "{{v1}} solo disponible en {{v2}}",
      "x_x_isnt_available": "{{v1}} {{v2}} no está disponible",
      "x_x_isnt_available_color_changed_to_x_subtitle": [
        "Cambió el color a {{v1}}"
      ],
      "x_x_isnt_available_color_changed_to_x_title": [
        "{{v1}} {{v2}} no está disponible"
      ],
      "x_available_in_selected_materials": "{{v1}} disponible en los materiales seleccionados"
    },
    "photo": {
      "edit_tile": "Editar Cuadro",
      "photo_tiles": "Cuadros de fotos"
    },
    "photo_book": {
      "product_names": {
        "newborn": "Álbum de Recién Nacido",
        "family": "Álbum Familiar",
        "annual": "Álbum Anual",
        "travel": "Álbum de Viajes",
        "wedding": "Álbum de Boda"
      },
      "add_photos_dialog": {
        "title": "¿Dónde deberíamos colocar tus nuevas fotos?",
        "add_chronologically": "Añadir cronológicamente",
        "add_at_end": "Añadir al final"
      },
      "added_in_chronological_order": "Añadido en orden cronológico",
      "arrange": {
        "name": "Organizar"
      },
      "arrival_notice": {
        "login_title_one": "Bienvenido de nuevo, {{count}} álbum restaurado en tu bolsa",
        "login_title_other": "Bienvenido de nuevo, {{count}} álbumes restaurados en tu bolsa",
        "title_one": "{{count}} álbum restaurado en tu bolsa",
        "title_other": "{{count}} álbumes restaurados en tu bolsa"
      },
      "cover": "Portada",
      "cover_edit": {
        "cover_photo_label": "Foto de Portada",
        "title": "Editar Portada",
        "title_font_label": "Fuente del Título",
        "title_label": "Título",
        "designed_covers": "Portadas de Diseñador",
        "upload": "Subir",
        "designs": "Diseños",
        "select_cover": "Elegir Portada",
        "crop_and_title_hint": "Pellizca para recortar, toca el título para editar",
        "ai_cover_create": "Crear",
        "ai_cover_title": "Título de tu libro",
        "ai_cover_headline_label": "Título de tu libro",
        "ai_cover_headline_placeholder": "Título de tu libro",
        "ai_cover_generate": "Crear portada",
        "ai_cover_retry": "Reintentar",
        "ai_cover_creating": "Creando portada",
        "ai_cover_ready_title": "Tu portada está lista",
        "ai_cover_ready_action": "Editar portada"
      },
      "cover_deep_link": {
        "rejected_title": "Algo salió mal. Intenta elegir una portada de nuevo"
      },
      "deep_link_photos": {
        "rejected_title": "Algo salió mal. Añade tus fotos para empezar el álbum"
      },
      "add_text": "Leyenda",
      "creating_book": "Creando álbum...",
      "default_cover_text": "Momentos Felices",
      "empty_book": "El álbum está vacío.",
      "title": "Título",
      "photo": "Foto",
      "ios_uploader": {
        "old_ux_message": "Una vez que presiones 'Agregar', espera 30 segundos para que se carguen las fotos",
        "old_ux_upload": "Subir Fotos"
      },
      "low_res_photos": {
        "cart_cta": "Revisar",
        "cart_label": "Fotos de baja resolución."
      },
      "not_enough_photos": {
        "cart_cta": "Añadir",
        "cart_label": "Añade {{numPhotos}} fotos más para terminar.",
        "cart_title": "Añade más fotos a tu álbum",
        "cta": "Agregar más fotos",
        "subtitle": "Has subido menos de {{totalAmount}} fotos. Añade {{missingAmount}} más para completar tu pedido.",
        "title": "No hay suficientes fotos"
      },
      "too_many_pages": {
        "title": "¡Casi listo! Tu álbum está un poco lleno de más",
        "subtitle": "Los álbumes pueden tener hasta {{maxPhotos}} fotos. Quita {{extraPhotos}} fotos para terminar tu álbum.",
        "cta": "Editar Mi Álbum"
      },
      "page_1": "Página 1",
      "page_controls": {
        "adjust_crop": "Pellizcar para ajustar el recorte",
        "delete_photo": "Eliminar",
        "replace_photo": "Reemplazar",
        "caption_too_long": "La leyenda es demasiado larga"
      },
      "page_order": {
        "done": "Listo",
        "snackbar": {
          "cover_back_cant_edit": "El dorso de la portada no se puede editar",
          "pages_sorted": "Páginas Ordenadas",
          "pages_sorted_by_date": "Páginas ordenadas por fecha",
          "undo": "Deshacer"
        },
        "sort_by_date": "Ordernar por Fecha",
        "sort_confirmation": {
          "approve": "Clasificar",
          "dismiss": "Cancelar",
          "main_text": "Ordenar Fotos de la más antigua a la más reciente",
          "title": "Ordenar Páginas por Fecha"
        },
        "subtitle": "Arrastra una foto para reorganizar",
        "title": "Revisión de Páginas",
        "warning": {
          "missing_date": "Las fotos marcadas no se ordenaron automáticamente porque falta la fecha. Por favor, organízalas manualmente"
        }
      },
      "page_range": "Página {{start}}-{{end}}",
      "page_single": "Página {{page}}",
      "pages_disabled_message": "Necesitas más fotos para reorganizar las páginas",
      "photo_deleted": "Foto eliminada",
      "photos_not_uploaded": {
        "title": "{{count}} fotos no se subieron",
        "subtitle": "Añádelas de nuevo antes de pagar"
      },
      "photo_limit": {
        "title": "Límite de fotos alcanzado",
        "message": "Límite de fotos alcanzado. Elimina algunas para agregar más",
        "subtitle_single": "Por favor elimina 1 foto",
        "subtitle_plural": "Por favor elimina {{v1}} fotos",
        "all_set": "¡Listo! Haz clic en '{{done}}' para continuar"
      },
      "size": "Medida",
      "size_selection": {
        "title": "Selecciona el Tamaño del Álbum",
        "select_size": "Selecciona el tamaño",
        "page_count": "Nº de Páginas",
        "tier_page_range": "{{start}} - {{end}} páginas",
        "current_tier": "Nivel actual"
      },
      "swipe_pages": "Deslizar página",
      "turn_pages": "Pasar Páginas",
      "updating_book": "Actualizando álbum...",
      "replacing_photo": "Reemplazando foto...",
      "uploading_photos": "Subiendo fotos"
    },
    "pitch": {
      "copyright": "© Copyright 2015-{{v1}} Mixtiles, LTD",
      "footer": {
        "about": "Sobre",
        "accessibility": "Declaración de Accesibilidad",
        "blog": "Nuestro Blog",
        "canvas_prints": "Impresiones en Lienzo",
        "careers": "Empleo",
        "cookie_policy": "Política de Cookies",
        "facebook": "Facebook",
        "follow_us": "Síguenos",
        "gallery_walls": "Paredes de Ensueño",
        "impressum": "Impressum",
        "instagram": "Instagram",
        "join_us": "Únete a Nosotros",
        "privacy": "Política de Privacidad",
        "products": "Productos",
        "resources": "Recursos",
        "terms_of_use": "Condiciones de Uso",
        "twitter": "Twitter",
        "tokushoho": "特定商取引法に基づく表記"
      },
      "footer_links": {
        "accessibility_statement": "DECLARACIÓN DE ACCESIBILIDAD",
        "impressum": "IMPRESSUM",
        "privacy_policy": "Política de Privacidad",
        "terms_of_use": "CONDICIONES DE USO",
        "cookie_policy": "POLÍTICA DE COOKIES"
      },
      "global_shipping": "Envío global, entrega rápida.",
      "headline": "Convierte tus fotos en preciosas obras de arte",
      "icons": {
        "satisfaction": {
          "text": [
            "Si no te encanta,",
            "te devolvemos el dinero"
          ],
          "title": "Satisfacción garantizada"
        }
      },
      "main_button_cta": "¡Vamos allá!"
    },
    "product": {
      "carousel": {
        "adjust_to_perfection": "Ajustados a la perfección",
        "no_damage": "No deja marcas",
        "peel_stick": "Solo quita el protector y pega"
      }
    },
    "product_page": {
      "art_product": {
        "description": "Arte que se pega a cualquier pared, no deja daño, y pueden cambiarse de lugar.",
        "description_mobile": {
          "no_nails": "Sin necesidad de clavos, se pegan a cualquier pared",
          "satisfaction": "Satisfacción garantizada"
        }
      },
      "choose_your_own_style": "Elegir tu propio estilo",
      "community": {
        "description": "Esto es lo que nuestros clientes dicen de nosotros",
        "load_more": "Cargar Más",
        "title": "Desde nuestra comunidad"
      },
      "controls": {
        "art": {
          "browse": "Explorar Arte",
          "start": "Añadir Arte"
        },
        "frame_size": "Tamaño del Marco",
        "frame_style": "Estilo del Marco",
        "tile": {
          "start": "Comenzar a Crear"
        },
        "photobook": {
          "start": "Comprar Ahora"
        }
      },
      "magnetic_hanging": {
        "description": "Alinea, ajusta y reacomoda tus cuadros a la perfección y fácilmente. Disfruta de paredes sin daños y de la libertad de renovar tu espacio en cualquier momento.",
        "title": "Descubre el sistema de sujeción magnética"
      },
      "photobook_product": {
        "beauty": {
          "subtitle": "Cada álbum viene con una cubierta dura y mate, y está impreso en páginas premium con un acabado sedoso",
          "title": "Belleza en Cada Página"
        },
        "bullet_points": {
          "free_shipping": "Envío gratis",
          "no_hidden_fees": "Sin cargos escondidos",
          "same_price": "Mismo precio, no importa el número de páginas",
          "simple_pricing": "Precios simples, sin sorpresas"
        },
        "description": "Diseña tu álbum con unos cuantos toques, y míralo cobrar vida en 3D.",
        "description_mobile": {
          "fixed_price": "Precio fijo, no importa cuántas páginas",
          "quality_book": "Impresiones con calidad de museo, álbum de tapa dura",
          "free_shipping": "Envío gratis"
        },
        "title": {
          "default": "Álbumes de Fotos Hecho Fácilmente"
        }
      },
      "price_each": "/ cada uno",
      "reviews_count": "Con más de 100.000 valoraciones en la App Store",
      "tile_product": {
        "description": "Cuadros impresos enmarcados que se adhieren a cualquier pared, no dejan daños y se pueden cambiar de lugar.",
        "description_mobile": {
          "no_nails": "Sin necesidad de clavos, se pegan a cualquier pared",
          "satisfaction": "Satisfacción garantizada"
        },
        "tile": "Cuadro",
        "title": {
          "canvas": "Impresiones en Lienzo para Pegar y Despegar",
          "regular": "Cuadros Fotográficos Re-adhesivos"
        }
      },
      "explore": {
        "art": "Explorar Arte",
        "canvas_prints": "Explorar Impresiones en Lienzo",
        "photo_books": "Explorar Libros de Fotos",
        "photo_tiles": "Explorar Cuadros Fotográficos"
      },
      "reviews_count_mobile": "100 mil+ valoraciones"
    },
    "product_selection": {
      "photo_books_name": "Libros de Fotos",
      "tiles_name": "Cuadros",
      "title_choose_what_to_create": "Elige qué crear"
    },
    "rating": {
      "back_to_mixtiles": "Volver a Mixtiles",
      "comment": {
        "1-2-stars": {
          "sentence": "¡Lo sentimos! ¿Podrías decirnos qué pasó?"
        },
        "3-4-stars": {
          "question": "¿Qué podríamos mejorar?",
          "sentence": "¡Queremos mejorar!"
        },
        "5-stars": {
          "question": "¿Qué es lo que más te gustó?",
          "sentence": "¡Nos alegra leer eso!"
        }
      },
      "contact_us": "Escribirnos",
      "feel_free": "Si hay algo más que podamos hacer por ti, no dudes en",
      "first_question": "¿Cómo fue tu experiencia de compra con Mixtiles?",
      "next": "Siguiente",
      "star_caption": {
        "1": "Horrible",
        "2": "Mala",
        "3": "Aceptable",
        "4": "Buena",
        "5": "Excelente"
      },
      "submit": "Enviar",
      "tell_us_here": "Cuéntanoslo aquí...",
      "thanks": "¡Gracias por tu opinión!"
    },
    "refresher_kit_request": {
      "back": "Atrás",
      "confirmation": {
        "received_title": "¡Recibimos tu solicitud!"
      },
      "contact_support": "Contactar con soporte",
      "continue": "Continuar",
      "continue_with_count": "Continuar ({{count}})",
      "errors": {
        "invalid_email": "Introduce un correo electrónico válido",
        "invalid_state": "Introduce un estado válido",
        "invalid_submission": "No pudimos aceptar esta solicitud. Revisa tu selección y tus datos e inténtalo de nuevo.",
        "load_failed": "Vaya, algo salió mal.",
        "required": "Obligatorio",
        "submit_failed": "No pudimos enviar tu solicitud. Inténtalo de nuevo."
      },
      "expired": {
        "body": "Contacta con nuestro equipo de soporte y te enviaremos uno nuevo.",
        "title": "Este enlace ha caducado"
      },
      "frame_name": "Marco {{v1}}",
      "inactive": {
        "body": "Contacta con nuestro equipo de soporte y te ayudaremos a resolverlo todo.",
        "title": "Este enlace ya no está activo"
      },
      "invalid_link": {
        "body": "Contacta con nuestro equipo de soporte y te ayudaremos a resolverlo todo.",
        "title": "Este enlace no es válido"
      },
      "no_orders": {
        "body": "Contacta con nuestro equipo de soporte y te ayudaremos a resolverlo todo.",
        "title": "No encontramos pedidos entregados en esta cuenta"
      },
      "select": {
        "title": "Selecciona los cuadros que necesitan renovarse y recibe adhesivos de repuesto"
      },
      "selected_badge": "{{v1}} seleccionados",
      "selected_of_tiles": "{{v1}}/{{v2}} cuadros",
      "sending": "Enviando tu solicitud...",
      "shipping": {
        "country": "País",
        "email": "Correo electrónico",
        "submit": "Enviarme el kit",
        "subtitle": "Tus adhesivos de repuesto se envían sin costo para ti.",
        "title": "¿A dónde lo enviamos?"
      },
      "summary": {
        "adhesives_many": "{{v1}} adhesivos de repuesto",
        "adhesives_one": "1 adhesivo de repuesto",
        "title": "Resumen del pedido ({{v1}})"
      },
      "switch_account": "Cambiar de cuenta",
      "tile_count_many": "{{v1}} cuadros",
      "tile_count_one": "1 cuadro",
      "try_again": "Intentar de nuevo",
      "wrong_account": {
        "body": "Inicia sesión con la cuenta a la que se envió este enlace o contacta con nuestro equipo de soporte.",
        "title": "Este enlace pertenece a otra cuenta"
      }
    },
    "referral": {
      "already_referred": "Ya enviaste una tarjetaeta de regalo a este destinatario. Por favor, ingresa un email distinto.",
      "general_error": "Ocurrió un error mientras se enviaba la tarjeta de regalo. Por favor, intenta de nuevo más tarde.",
      "login": "Inicia Sesión para Continuar",
      "menu_title": "Programa de Referencia",
      "referral_sent": "<div>¡La tarjeta de regalo está en camino a <b>{{v1}}</b>!<br> Después de su compra, recibirás <b>{{v2}}</b> en créditos y se te notificará por email.</div>",
      "self_referral": "No puedes enviarte una tarjeta de regalo de referencia a ti mismo. Por favor, ingresa un email distinto.",
      "send": "Enviar Ahora",
      "subtitle": "Por cada amigo que realice una compra, obtendrás {{v1}} en créditos - ¡es gratis!",
      "title": "Da {{v1}}, Obtén {{v1}}"
    },
    "size_selection": {
      "price_per_tile": "{{v1}} por cuadro"
    },
    "wall_designer": {
      "highlighted_tile": {
        "edit_tile": "Editar cuadro",
        "swap_position": "Cambiar posición",
        "swap_position_title": "Elige una foto para intercambiar"
      },
      "photos_selector": {
        "selected": "seleccionadas",
        "title": "Selecciona {{v1}} fotos"
      },
      "preferences_saved": {
        "cta": "Regresar a la página de principal.",
        "subtitle": "Esperamos verte pronto para conocer más productos y ofertas interesantes.",
        "title": "Tus preferencias han sido actualizadas."
      },
      "zoom_button": {
        "full_view": "Vista completa",
        "zoom": "Acercar"
      }
    },
    "wall_feed": {
      "categories": {
        "large": "Grande",
        "medium": "Mediano",
        "small": "Pequeño"
      }
    },
    "cancel_order_v2": {
      "cta": "Cancelar Pedido",
      "dialog": {
        "title": "Cancelar Pedido",
        "refund_content": "Recibirás un reembolso completo de {{sum}}.",
        "refund_refund_info": "El reembolso se aplicará a tu método de pago original.",
        "dismiss": "Conservar mi pedido"
      }
    },
    "seo": {
      "art": {
        "base": {
          "title": "Arte de Mixtiles",
          "description": "Convierte tus fotos en arte de pared impresionante y asequible"
        }
      },
      "canvas": {
        "base": {
          "title": "Impresiones en lienzo de Mixtiles",
          "h1": "Impresiones personalizadas en lienzo",
          "description": "Convierte tus fotos personales en impresionantes cuadros que puedes colgar en cualquier lugar, ¡sin usar clavos!"
        },
        "sized": {
          "title": "Impresiones en lienzo {{size}} de Mixtiles",
          "h1": "Impresiones en lienzo {{size}}",
          "description": "Transforma tus fotos en hermosas impresiones en lienzo {{size}} — sin clavos, sin daños, solo arte de pared fácil."
        }
      },
      "phototiles": {
        "base": {
          "title": "Cuadros adhesivos de Mixtiles",
          "h1": "Cuadros adhesivos",
          "description": "Convierte tus fotos en impresionantes cuadros adhesivos sin clavos ni daños en la pared con Mixtiles."
        },
        "sized": {
          "title": "Cuadros {{size}} de Mixtiles",
          "h1": "Cuadros {{size}}",
          "description": "Convierte tus fotos en elegantes cuadros adhesivos {{size}} que se pegan a la pared sin clavos ni herramientas."
        },
        "withMaterial": {
          "title": "Cuadros {{size}} {{frameDisplay}} de Mixtiles",
          "h1": "Cuadros {{size}} {{frameDisplay}}",
          "description": "Convierte tus fotos en elegantes cuadros adhesivos {{size}} {{frameDisplayLower}} que se pegan a la pared sin clavos ni herramientas."
        }
      },
      "photobooks": {
        "base": {
          "title": "Álbumes de fotos de Mixtiles",
          "h1": "Álbumes de fotos",
          "description": "Crea hermosos álbumes de fotos con Mixtiles. Convierte tus recuerdos en recuerdos duraderos que duran toda la vida."
        },
        "sized": {
          "title": "Álbum de fotos {{size}} de Mixtiles",
          "h1": "Álbum de fotos {{size}}",
          "description": "{{description}}"
        },
        "wedding": {
          "title": "Álbumes de boda de Mixtiles",
          "h1": "Álbumes de boda",
          "description": "Celebra tu historia de amor con álbumes de boda de Mixtiles. Crea hermosos recuerdos, revive momentos preciosos y disfruta de calidad que dura toda la vida.",
          "sized": {
            "title": "Álbum de boda {{size}} de Mixtiles",
            "h1": "Álbum de boda {{size}}"
          }
        },
        "memory": {
          "title": "Álbum de recuerdos de Mixtiles",
          "h1": "Álbum de recuerdos",
          "description": "Convierte tus recuerdos favoritos en un hermoso Álbum de recuerdos de Mixtiles. ¡Revive cada momento con todo detalle!",
          "sized": {
            "title": "Álbum de recuerdos {{size}} de Mixtiles",
            "h1": "Álbum de recuerdos {{size}}"
          }
        },
        "small": {
          "title": "Álbum de fotos pequeño de Mixtiles",
          "h1": "Álbum de fotos pequeño",
          "description": "Muestra los mejores momentos pequeños de la vida con un Álbum de fotos pequeño de Mixtiles. Grandes recuerdos, compactos y hermosos.",
          "sized": {
            "title": "Álbum de fotos pequeño {{size}} de Mixtiles",
            "h1": "Álbum de fotos pequeño {{size}}"
          }
        },
        "boudoir": {
          "title": "Álbum de fotos boudoir de Mixtiles",
          "h1": "Álbum de fotos boudoir",
          "description": "Celebra tu confianza con un Álbum de fotos boudoir de Mixtiles. Un recuerdo audaz y hermoso hecho solo para ti.",
          "sized": {
            "title": "Álbum de fotos boudoir {{size}} de Mixtiles",
            "h1": "Álbum de fotos boudoir {{size}}"
          }
        },
        "travel": {
          "title": "Álbum de viajes de Mixtiles",
          "h1": "Álbum de viajes",
          "description": "Muestra tus aventuras con un Álbum de viajes de Mixtiles. Captura tus viajes, revive cada momento y guarda tus recuerdos de viaje siempre cerca.",
          "sized": {
            "title": "Álbum de viajes {{size}} de Mixtiles",
            "h1": "Álbum de viajes {{size}}"
          }
        },
        "coffee-table": {
          "title": "Álbum de fotos de mesa de centro de Mixtiles",
          "h1": "Álbum de mesa de centro",
          "description": "Añade personalidad a tu decoración con un Álbum de mesa de centro de Mixtiles. Estilo y recuerdos en una sola pieza perfecta.",
          "sized": {
            "title": "Álbum de mesa de centro {{size}} de Mixtiles",
            "h1": "Álbum de mesa de centro {{size}}"
          }
        },
        "engagement": {
          "title": "Álbum de compromiso de Mixtiles",
          "h1": "Álbum de compromiso",
          "description": "Captura tu historia de amor con un Álbum de compromiso de Mixtiles. Un recuerdo que atesorarás para siempre.",
          "sized": {
            "title": "Álbum de compromiso {{size}} de Mixtiles",
            "h1": "Álbum de compromiso {{size}}"
          }
        },
        "family": {
          "title": "Álbum de fotos familiar de Mixtiles",
          "h1": "Álbum familiar",
          "description": "Celebra los hitos familiares con un Álbum familiar de Mixtiles. Recuerdos que amarás compartir una y otra vez.",
          "sized": {
            "title": "Álbum familiar {{size}} de Mixtiles",
            "h1": "Álbum familiar {{size}}"
          }
        },
        "anniversary": {
          "title": "Álbum de aniversario de Mixtiles",
          "h1": "Álbum de aniversario",
          "description": "Honra tu historia de amor con un Álbum de aniversario de Mixtiles. Celebra años de recuerdos de forma hermosa.",
          "sized": {
            "title": "Álbum de aniversario {{size}} de Mixtiles",
            "h1": "Álbum de aniversario {{size}}"
          }
        },
        "pet-dog": {
          "title": "Álbum de fotos de perro de Mixtiles",
          "h1": "Álbum de perro",
          "description": "Celebra a tu mejor amigo peludo con un Álbum de fotos de perro de Mixtiles. Cada movimiento de cola, capturado para siempre.",
          "sized": {
            "title": "Álbum de perro {{size}} de Mixtiles",
            "h1": "Álbum de perro {{size}}"
          }
        },
        "mothers-day": {
          "title": "Álbum del Día de la Madre de Mixtiles",
          "h1": "Álbum del Día de la Madre",
          "description": "Regálale a mamá el mejor recuerdo con un Álbum del Día de la Madre de Mixtiles. Lleno de amor, risas y recuerdos.",
          "sized": {
            "title": "Álbum del día de la madre {{size}} de Mixtiles",
            "h1": "Álbum del día de la madre {{size}}"
          }
        },
        "christmas": {
          "title": "Álbum de Navidad de Mixtiles",
          "h1": "Álbum de Navidad",
          "description": "Comparte la magia de las fiestas con un Álbum de Navidad de Mixtiles. Un regalo que atesorarán año tras año.",
          "sized": {
            "title": "Álbum de navidad {{size}} de Mixtiles",
            "h1": "Álbum de navidad {{size}}"
          }
        },
        "fathers-day": {
          "title": "Álbum del Día del Padre de Mixtiles",
          "h1": "Álbum del Día del Padre",
          "description": "Hazle saber a papá que es tu héroe con un Álbum del Día del Padre de Mixtiles. Historias que atesorará para siempre.",
          "sized": {
            "title": "Álbum del día del padre {{size}} de Mixtiles",
            "h1": "Álbum del día del padre {{size}}"
          }
        },
        "retirement": {
          "title": "Álbum de jubilación de Mixtiles",
          "h1": "Álbum de jubilación",
          "description": "Celebra nuevos comienzos con un Álbum de jubilación de Mixtiles. Recuerdos de trabajo duro y un merecido descanso.",
          "sized": {
            "title": "Álbum de jubilación {{size}} de Mixtiles",
            "h1": "Álbum de jubilación {{size}}"
          }
        },
        "birthday": {
          "title": "Álbum de cumpleaños de Mixtiles",
          "h1": "Álbum de cumpleaños",
          "description": "Convierte recuerdos de cumpleaños en tesoros duraderos con un Álbum de cumpleaños de Mixtiles. ¡Cada año merece una página!",
          "sized": {
            "title": "Álbum de cumpleaños {{size}} de Mixtiles",
            "h1": "Álbum de cumpleaños {{size}}"
          }
        },
        "graduation": {
          "title": "Álbum de graduación de Mixtiles",
          "h1": "Álbum de graduación",
          "description": "Marca este hito con un Álbum de graduación de Mixtiles. Captura todos los momentos que hicieron que el viaje valiera la pena.",
          "sized": {
            "title": "Álbum de graduación {{size}} de Mixtiles",
            "h1": "Álbum de graduación {{size}}"
          }
        },
        "yearly": {
          "title": "Álbum anual de Mixtiles",
          "h1": "Álbum anual",
          "description": "Cuenta la historia de tu año con un Álbum anual de Mixtiles. Cada momento destacado, cada recuerdo, en un solo lugar.",
          "sized": {
            "title": "Álbum anual {{size}} de Mixtiles",
            "h1": "Álbum anual {{size}}"
          }
        },
        "valentines": {
          "title": "Álbum de San Valentín de Mixtiles",
          "h1": "Álbum de San Valentín",
          "description": "Celebra el amor con un Álbum de San Valentín de Mixtiles. Recuerdos más dulces que el chocolate.",
          "sized": {
            "title": "Álbum de san valentín {{size}} de Mixtiles",
            "h1": "Álbum de san valentín {{size}}"
          }
        },
        "recipe": {
          "title": "Álbum de recetas de Mixtiles",
          "h1": "Álbum de recetas",
          "description": "Saborea cada momento delicioso con un Álbum de recetas de Mixtiles. Tus platos favoritos, para siempre a tu alcance.",
          "sized": {
            "title": "Álbum de recetas {{size}} de Mixtiles",
            "h1": "Álbum de recetas {{size}}"
          }
        },
        "deals": {
          "title": "Ofertas de Álbumes de Fotos de Mixtiles",
          "h1": "Ofertas de Álbumes de Fotos",
          "description": "Encuentra increíbles ofertas de álbumes de fotos con Mixtiles. Crea hermosos álbumes de fotos a precios inmejorables y convierte tus recuerdos en tesoros duraderos.",
          "sized": {
            "title": "Ofertas de Álbumes de Fotos {{size}} de Mixtiles",
            "h1": "Ofertas de Álbumes de Fotos {{size}}"
          }
        },
        "designed-covers": {
          "title": "Álbum de Fotos con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Fotos con Portadas de Diseño",
          "description": "Dale un acabado elegante a tu álbum con un Álbum de Fotos con Portadas de Diseño de Mixtiles. Elige entre hermosas portadas y convierte tus recuerdos en un tesoro digno de presumir.",
          "sized": {
            "title": "Álbum de Fotos con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Fotos con Portadas de Diseño {{size}}"
          }
        },
        "baby": {
          "title": "Álbum de fotos de bebé de Mixtiles",
          "h1": "Álbum de fotos de bebé",
          "description": "Convierte el primer año en un Álbum de fotos de bebé de Mixtiles. Elige tus fotos favoritas, añade un título y recibe un libro hecho para leerse cien veces.",
          "sized": {
            "title": "Álbum de fotos de bebé {{size}} de Mixtiles",
            "h1": "Álbum de fotos de bebé {{size}}"
          }
        },
        "wedding-designed-covers": {
          "title": "Álbum de Boda con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Boda con Portadas de Diseño",
          "description": "Empieza tu álbum de boda con una portada diseñada para él. Elige el estilo que te encante, añade tus fotos y Mixtiles imprime un libro digno de presumir.",
          "sized": {
            "title": "Álbum de Boda con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Boda con Portadas de Diseño {{size}}"
          }
        },
        "baby-designed-covers": {
          "title": "Álbum de Bebé con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Bebé con Portadas de Diseño",
          "description": "Elige una portada diseñada para fotos de bebé y deja que Mixtiles llene las páginas con el primer año. Sin maquetar nada: elige y añade tus fotos.",
          "sized": {
            "title": "Álbum de Bebé con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Bebé con Portadas de Diseño {{size}}"
          }
        },
        "birthday-designed-covers": {
          "title": "Álbum de Cumpleaños con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Cumpleaños con Portadas de Diseño",
          "description": "Envuelve un año de fotos de cumpleaños en una portada diseñada para la ocasión. Elige el estilo, añade tus fotos y Mixtiles lo convierte en un regalo.",
          "sized": {
            "title": "Álbum de Cumpleaños con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Cumpleaños con Portadas de Diseño {{size}}"
          }
        },
        "coffee-table-designed-covers": {
          "title": "Álbum de Mesa de Centro con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Mesa de Centro con Portadas de Diseño",
          "description": "Una portada diseñada para un álbum que se queda a la vista. Elige el estilo, añade tus mejores fotos y Mixtiles les da un acabado para presumir.",
          "sized": {
            "title": "Álbum de Mesa de Centro con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Mesa de Centro con Portadas de Diseño {{size}}"
          }
        },
        "proposal-designed-covers": {
          "title": "Álbum de Propuesta con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Propuesta con Portadas de Diseño",
          "description": "Guarda la propuesta en un álbum con una portada diseñada para ella. Elige el estilo, añade las fotos del día y revive el sí cuando quieras.",
          "sized": {
            "title": "Álbum de Propuesta con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Propuesta con Portadas de Diseño {{size}}"
          }
        },
        "christmas-designed-covers": {
          "title": "Álbum de Navidad con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Navidad con Portadas de Diseño",
          "description": "Dale a tus fotos de Navidad una portada diseñada para la temporada. Elige el estilo, añade tus fotos y tendrás un álbum que abrirás cada año.",
          "sized": {
            "title": "Álbum de Navidad con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Navidad con Portadas de Diseño {{size}}"
          }
        },
        "family-designed-covers": {
          "title": "Álbum Familiar con Portadas de Diseño de Mixtiles",
          "h1": "Álbum Familiar con Portadas de Diseño",
          "description": "Elige una portada diseñada para tu álbum familiar y deja que Mixtiles convierta los momentos cotidianos en un tesoro para compartir.",
          "sized": {
            "title": "Álbum Familiar con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum Familiar con Portadas de Diseño {{size}}"
          }
        },
        "school-years-designed-covers": {
          "title": "Álbum de Años Escolares con Portadas de Diseño de Mixtiles",
          "h1": "Álbum de Años Escolares con Portadas de Diseño",
          "description": "Reúne los años escolares en un álbum con una portada diseñada para ellos. Elige el estilo, añade las fotos y mira cómo se llenan las páginas.",
          "sized": {
            "title": "Álbum de Años Escolares con Portadas de Diseño {{size}} de Mixtiles",
            "h1": "Álbum de Años Escolares con Portadas de Diseño {{size}}"
          }
        }
      },
      "variant_links": {
        "phototiles_material": "Cuadros Fotográficos {{frameDisplay}}"
      }
    },
    "tile_upsell": {
      "centerpiece": {
        "button": "Personalizar Ahora",
        "subtitle": "Solo {{price}}",
        "title": "Añade un cartel personalizado a tu pared"
      },
      "collage": {
        "button": "Personalizar Ahora",
        "subtitle": "{{size}} por {{price}}",
        "title": "Un collage de tus fotos puede ser un gran regalo"
      },
      "referral": {
        "button": "Compartir enlace",
        "subtitle": "Este enlace les da ${{price}} de descuento",
        "title": "¿Tienes amigos a los que les encantaría Mixtiles?"
      },
      "title": "¡Pedido Completado!"
    }
  }
}
